// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M6 12.5l4 4L18 8%27 fill=%27none%27 stroke=%27white%27 stroke-width=%273%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sb-page {
  --sb-blue: #165bfb;
  --sb-ink: #202c42;
  --sb-muted: #7a8496;
  --sb-line: #e8ecf2;
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: var(--sb-ink);
  background: #f8f9fc;
  font-family:
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    sans-serif;
  font-size: 14px;
}
.sb-page button,
.sb-page input,
.sb-page textarea,
.sb-page select {
  font: inherit;
}
.sb-page button,
.sb-page a,
.sb-page summary {
  -webkit-tap-highlight-color: transparent;
}
.sb-page button {
  cursor: pointer;
}
.sb-page button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.sb-page :focus-visible {
  outline: 3px solid #8eb3ff;
  outline-offset: 3px;
}
.sb-global-header {
  flex-shrink: 0;
  background: #fff;
}
.sb-app {
  display: flex;
  flex: 1;
  min-height: 0;
}
.sb-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.sb-sidebar {
  display: flex;
  flex-direction: column;
  flex: 0 0 258px;
  min-height: 0;
  padding: 28px 18px 18px;
  border-right: 1px solid var(--sb-line);
  background: #fff;
}
.sb-sidebar-title {
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 0 7px 27px;
}
.sb-brand-symbol {
  display: grid;
  place-items: center;
  width: 37px;
  height: 39px;
  color: var(--sb-blue);
  background: #edf3ff;
  border-radius: 12px;
}
.sb-sidebar-title strong {
  display: block;
  font-size: 16px;
  letter-spacing: -0.4px;
}
.sb-sidebar-title div > span {
  display: block;
  color: var(--sb-muted);
  font-size: 11px;
  margin-top: 2px;
}
.sb-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 43px;
  padding: 11px 17px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;
  transition:
    background 0.15s,
    box-shadow 0.15s;
}
.sb-button-primary {
  background: var(--sb-blue);
  color: white;
  box-shadow: 0 3px 5px #165bfb12;
}
.sb-button-primary:hover:not(:disabled) {
  background: #084ee9;
  box-shadow: 0 4px 12px #165bfb25;
}
.sb-button-secondary {
  border-color: #d8e0ee;
  background: white;
  color: #495870;
}
.sb-wide {
  width: 100%;
}
.sb-new-button {
  justify-content: flex-start;
  margin-bottom: 20px;
}
.sb-search {
  display: flex;
  gap: 9px;
  align-items: center;
  color: #8f9aab;
  border: 1px solid var(--sb-line);
  border-radius: 8px;
  padding: 9px 11px;
}
.sb-search input {
  min-width: 0;
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 11px;
  color: var(--sb-ink);
}
.sb-search:focus-within {
  border-color: #a0bffd;
}
.sb-sidebar-section-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 27px 8px 12px;
  color: #939dad;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 1px;
}
.sb-sidebar-section-heading > span:last-child {
  padding: 1px 5px;
  background: #f0f3f7;
  border-radius: 4px;
  font-size: 9px;
}
.sb-session-list {
  flex: 1;
  overflow-y: auto;
  min-height: 80px;
}
.sb-session {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border-radius: 9px;
  text-align: left;
  padding: 13px 9px;
  margin-bottom: 5px;
  background: transparent;
  color: #68758b;
  border: 1px solid transparent;
}
.sb-session:hover {
  background: #f8faff;
}
.sb-session.is-active {
  color: var(--sb-blue);
  background: #eff4ff;
  border-color: #e0eaff;
}
.sb-session-icon {
  flex-shrink: 0;
  align-self: flex-start;
  margin-top: 2px;
}
.sb-session > span:nth-child(2) {
  flex: 1;
  min-width: 0;
}
.sb-session strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
}
.sb-session small {
  display: flex;
  gap: 6px;
  align-items: center;
  color: #95a0b0;
  font-size: 10px;
  margin-top: 5px;
}
.sb-session small i {
  width: 2px;
  height: 2px;
  border-radius: 100%;
  background: currentColor;
}
.sb-sidebar-message {
  color: var(--sb-muted);
  font-size: 12px;
  padding: 10px 8px;
  line-height: 1.8;
}
.sb-sidebar-footer {
  padding: 17px 13px 12px;
  background: #f8f9fc;
  border: 1px solid #edf0f6;
  border-radius: 11px;
  margin-top: 18px;
}
.sb-sidebar-footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: #53617a;
}
.sb-sidebar-footer p {
  font-size: 10px;
  color: #8a94a5;
  line-height: 1.8;
  margin: 9px 0 12px;
}
.sb-sidebar-footer a {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  font-weight: 600;
  color: var(--sb-blue);
  text-decoration: none;
}
.sb-main {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: auto;
}
.sb-new-site {
  position: relative;
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  align-content: center;
  gap: 26px 12px;
  max-width: 1090px;
  min-height: 100%;
  margin: auto;
  padding: 45px 64px 35px;
}
.sb-new-intro {
  align-self: center;
}
.sb-kicker {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 8px;
  letter-spacing: 1.3px;
  font-weight: 700;
  color: #7b8eae;
}
.sb-kicker svg {
  color: var(--sb-blue);
}
.sb-new-intro h1 {
  font-size: clamp(32px, 3.4vw, 48px);
  line-height: 1.16;
  font-weight: 600;
  letter-spacing: -2px;
  margin: 18px 0 17px;
}
.sb-new-intro h1 > span {
  color: var(--sb-blue);
}
.sb-new-intro > p {
  color: #838da0;
  font-size: 12px;
  line-height: 1.9;
}
.sb-idea-art {
  width: 290px;
  height: 240px;
  position: relative;
  justify-self: end;
  align-self: center;
}
.sb-art-orbit {
  position: absolute;
  border: 1px dashed #dfe5f2;
  border-radius: 50%;
  width: 245px;
  height: 245px;
  top: -5px;
  left: 25px;
  transform: rotate(-25deg);
}
.sb-art-orbit-two {
  width: 285px;
  height: 185px;
  top: 30px;
  left: 0;
  transform: rotate(30deg);
  border-color: #e9edf6;
}
.sb-art-browser {
  position: absolute;
  top: 47px;
  left: 39px;
  width: 239px;
  height: 160px;
  background: white;
  border: 1px solid #dde4f0;
  border-radius: 9px;
  transform: rotate(-5deg);
  box-shadow: 0 14px 36px #324e7c0c;
  overflow: hidden;
}
.sb-art-browser-top {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 21px;
  background: #f9fafc;
  border-bottom: 1px solid #ecf0f7;
  padding: 0 8px;
}
.sb-art-browser-top > i {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #d9e2f0;
}
.sb-art-browser-top > span {
  width: 89px;
  height: 7px;
  margin-left: 28px;
  border-radius: 3px;
  background: #eaf0f8;
}
.sb-art-browser-body {
  padding: 12px 14px;
}
.sb-art-nav {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 14px;
}
.sb-art-nav b {
  width: 28px;
  height: 6px;
  background: #7c9ad7;
  border-radius: 2px;
  margin-right: auto;
}
.sb-art-nav span {
  width: 15px;
  height: 3px;
  background: #dce4f1;
  border-radius: 2px;
}
.sb-art-hero {
  display: flex;
  gap: 16px;
}
.sb-art-hero > div:first-child {
  flex: 1;
  padding-top: 4px;
}
.sb-art-hero i {
  display: block;
  width: 87px;
  height: 8px;
  background: #b5c8e9;
  border-radius: 2px;
  margin-bottom: 5px;
}
.sb-art-hero i:nth-child(2) {
  width: 65px;
  background: #c7d7ef;
}
.sb-art-hero p {
  height: 3px;
  background: #e2e8f2;
  margin-top: 5px;
  width: 91px;
}
.sb-art-hero p:nth-of-type(2) {
  width: 63px;
}
.sb-art-hero b {
  display: block;
  height: 12px;
  width: 36px;
  border-radius: 3px;
  background: #165bfb;
  margin-top: 9px;
}
.sb-art-image {
  position: relative;
  width: 82px;
  height: 70px;
  background: #e8edf9;
  border-radius: 4px;
  overflow: hidden;
}
.sb-art-image span:first-child {
  position: absolute;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #c2d0ee;
  left: 34px;
  top: -8px;
}
.sb-art-image span:last-child {
  position: absolute;
  width: 65px;
  height: 75px;
  border-radius: 38px 38px 0 0;
  background: #96aedf;
  top: 26px;
  left: 10px;
  transform: rotate(-25deg);
}
.sb-art-cards {
  display: flex;
  gap: 6px;
  margin-top: 12px;
}
.sb-art-cards i {
  flex: 1;
  height: 16px;
  background: #f0f4fa;
  border-radius: 3px;
}
.sb-art-note {
  position: absolute;
  top: 13px;
  left: 4px;
  z-index: 1;
  width: 94px;
  padding: 12px;
  background: #fff;
  border: 1px solid #dfe7f6;
  color: var(--sb-blue);
  box-shadow: 0 5px 18px #1a3e7810;
  border-radius: 9px;
  transform: rotate(-9deg);
}
.sb-art-note > span {
  position: absolute;
  left: 36px;
  top: 15px;
  font-size: 9px;
  font-weight: 600;
  color: #5e7299;
}
.sb-art-note i {
  display: block;
  background: #e3eaf7;
  height: 3px;
  margin-top: 7px;
  border-radius: 2px;
}
.sb-art-note i:last-child {
  width: 70%;
}
.sb-art-spark {
  position: absolute;
  right: -1px;
  top: 28px;
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  color: #e1a04c;
  border-radius: 11px;
  transform: rotate(12deg);
  background: #fff6e5;
  border: 1px solid #f6e7cc;
}
.sb-art-done {
  position: absolute;
  bottom: 18px;
  left: 23px;
  z-index: 1;
  display: flex;
  gap: 5px;
  align-items: center;
  background: #fff;
  border: 1px solid #e3eced;
  border-radius: 7px;
  padding: 9px 10px;
  font-size: 8px;
  color: #739084;
  box-shadow: 0 4px 14px #1d5a3910;
  transform: rotate(2deg);
}
.sb-idea-form {
  grid-column: 1 / -1;
  background: #fff;
  border: 1px solid #dde5f1;
  border-radius: 15px;
  padding: 23px 24px 17px;
  box-shadow: 0 8px 28px #304a7605;
}
.sb-idea-form:focus-within {
  border-color: #9dbbfa;
  box-shadow: 0 0 0 3px #165bfb05;
}
.sb-idea-form > label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 12px;
}
.sb-idea-form > textarea {
  resize: vertical;
  min-height: 100px;
  max-height: 260px;
  outline: none;
  border: 0;
  background: transparent;
  width: 100%;
  font-size: 12px;
  line-height: 1.9;
  color: var(--sb-ink);
}
.sb-idea-form > textarea::-moz-placeholder {
  color: #a4adbc;
}
.sb-idea-form > textarea::placeholder {
  color: #a4adbc;
}
.sb-idea-options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #f0f2f7;
  padding-top: 14px;
  margin-top: 8px;
}
.sb-session-name {
  display: flex;
  gap: 7px;
  align-items: center;
  color: #9ca6b6;
  flex: 1;
  min-width: 120px;
}
.sb-session-name input {
  min-width: 0;
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  font-size: 11px;
  color: #647189;
}
.sb-required-label {
  color: #647189;
  font-size: 11px;
  font-weight: 400;
}
.sb-idea-options select {
  background: #f7f9fc;
  color: #66748b;
  border: 1px solid #e9edf4;
  border-radius: 7px;
  padding: 8px 7px;
  font-size: 10px;
}
.sb-idea-options .sb-button {
  font-size: 11px;
  min-height: 38px;
  padding: 9px 13px;
}
.sb-idea-starters {
  grid-column: 1 / -1;
  margin-top: 4px;
}
.sb-idea-starters > span {
  display: block;
  font-size: 8px;
  font-weight: 600;
  letter-spacing: 1.2px;
  color: #9aa3b4;
  margin-bottom: 13px;
}
.sb-idea-starters > div {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.sb-idea-starters button {
  position: relative;
  text-align: left;
  padding: 15px 13px;
  border: 1px solid #e7ebf3;
  border-radius: 10px;
  background: #fff9;
  transition:
    background 0.2s,
    border-color 0.2s;
}
.sb-idea-starters button:hover {
  background: white;
  border-color: #adc7ff;
}
.sb-starter-icon {
  display: block;
  color: #7992bc;
  margin-bottom: 11px;
}
.sb-starter-1 {
  color: #9a85b7;
}
.sb-starter-2 {
  color: #b49b72;
}
.sb-idea-starters strong {
  font-size: 11px;
  font-weight: 600;
}
.sb-idea-starters p {
  color: #919bad;
  font-size: 9px;
  line-height: 1.6;
  margin-top: 5px;
}
.sb-idea-starters button > svg {
  position: absolute;
  right: 12px;
  top: 17px;
  color: #a3afc2;
}
.sb-new-footnote {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 19px;
  grid-column: 1 / -1;
  margin-top: 10px;
  color: #a4adbc;
  font-size: 8px;
}
.sb-new-footnote b {
  color: #8c97aa;
  font-weight: 400;
  margin-left: 4px;
}
.sb-new-footnote i {
  width: 27px;
  height: 1px;
  background: #e1e6ef;
}
.sb-workspace {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.sb-workspace-header {
  padding: 25px 30px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  background: white;
}
.sb-eyebrow {
  display: block;
  color: #9aa4b4;
  font-size: 8px;
  letter-spacing: 1.2px;
  font-weight: 600;
}
.sb-workspace-header h1 {
  font-size: 21px;
  font-weight: 600;
  letter-spacing: -0.6px;
  margin-top: 6px;
  overflow-wrap: anywhere;
}
.sb-workspace-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.sb-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border: 1px solid #e2eaf8;
  border-radius: 6px;
  color: #6884b1;
  background: #f7faff;
  font-size: 9px;
  white-space: nowrap;
}
.sb-status-pill i {
  width: 5px;
  height: 5px;
  background: #8faee6;
  border-radius: 100%;
}
.sb-icon-button {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border: 1px solid #e7ecf4;
  background: white;
  color: #8896ad;
  border-radius: 7px;
}
.sb-steps {
  display: flex;
  flex-shrink: 0;
  list-style: none;
  gap: 10px;
  padding: 0 30px 20px;
  background: white;
  border-bottom: 1px solid var(--sb-line);
  margin: 0;
}
.sb-steps li {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #a6afbd;
  font-size: 9px;
  white-space: nowrap;
  flex: 1;
}
.sb-steps li:not(:last-child)::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #e9edf4;
  margin-left: 3px;
}
.sb-steps li > span {
  display: grid;
  place-items: center;
  width: 19px;
  height: 19px;
  border-radius: 50%;
  font-size: 8px;
  background: #f1f4f9;
  border: 1px solid #e9edf3;
}
.sb-steps li.is-current {
  color: var(--sb-blue);
  font-weight: 600;
}
.sb-steps li.is-current > span {
  color: white;
  background: var(--sb-blue);
  border-color: var(--sb-blue);
}
.sb-steps li.is-done {
  color: #7089af;
}
.sb-steps li.is-done > span {
  color: #6f97c2;
  background: #eff6ff;
  border-color: #e0ebfc;
}
.sb-workspace-columns {
  display: grid;
  grid-template-columns: minmax(300px, 1fr) 340px;
  flex: 1;
  min-height: 0;
}
.sb-conversation {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  background: #fcfdff;
}
.sb-conversation-top {
  display: flex;
  gap: 9px;
  align-items: center;
  padding: 19px 26px;
  border-bottom: 1px solid #eef1f6;
}
.sb-evo-avatar {
  display: grid;
  place-items: center;
  width: 33px;
  height: 33px;
  flex-shrink: 0;
  border: 1px solid #e0e9ff;
  border-radius: 11px;
  color: var(--sb-blue);
  background: linear-gradient(135deg, #f0f5ff, #f7f5ff);
}
.sb-conversation-top strong {
  display: block;
  font-size: 12px;
  font-weight: 600;
}
.sb-conversation-top div > span {
  display: block;
  color: #94a0b2;
  font-size: 9px;
  margin-top: 3px;
}
.sb-text-only {
  color: #a7b0bf;
  font-size: 9px;
  margin-left: auto;
}
.sb-messages {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 19px 30px;
  scroll-behavior: smooth;
}
.sb-conversation-start {
  display: flex;
  align-items: center;
  gap: 13px;
  color: #aab3c3;
  font-size: 7px;
  letter-spacing: 1.5px;
  margin-bottom: 28px;
}
.sb-conversation-start::before,
.sb-conversation-start::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #edf0f5;
}
.sb-welcome-message {
  display: flex;
  gap: 12px;
  max-width: 460px;
  margin-bottom: 22px;
}
.sb-welcome-message h2 {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.4px;
  margin: 6px 0 10px;
}
.sb-welcome-message p {
  color: #8692a5;
  font-size: 12px;
  line-height: 1.9;
}
.sb-message {
  max-width: 94%;
  margin-bottom: 24px;
}
.sb-message-user {
  margin-left: 28px;
}
.sb-message-author {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 9px;
  color: #91a0b6;
  margin-bottom: 8px;
}
.sb-message-author strong {
  font-weight: 600;
  color: #64738a;
}
.sb-message-author time {
  font-size: 8px;
  margin-left: 3px;
  color: #a8b2c2;
}
.sb-message-author > svg {
  color: var(--sb-blue);
}
.sb-message-content {
  overflow-wrap: anywhere;
  font-size: 12px;
  line-height: 1.95;
  color: #58667d;
}
.sb-message-content a {
  color: var(--sb-blue);
  text-decoration: underline;
  text-underline-offset: 3px;
}
.sb-message-user .sb-message-content {
  white-space: pre-wrap;
  padding: 13px 17px;
  background: #edf3ff;
  border: 1px solid #e4ecfc;
  border-radius: 12px 3px 12px 12px;
  color: #496088;
}
.sb-message-pending {
  opacity: 0.7;
}
/* The question Evo asks, in a panel above the message box: borderless option rows, the choice shown by a light
   blue fill. Single cards and question groups share it. */
.sb-question-panel {
  position: relative;
  margin-bottom: 8px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(33, 39, 54, 0.06);
  color: #212736;
  font-size: 16px;
  line-height: 24px;
}
.sb-question-panel *,
.sb-question-panel *::before,
.sb-question-panel *::after {
  box-sizing: border-box;
}
.sb-question-panel__toggle {
  position: absolute;
  top: 14px;
  right: 8px;
  z-index: 1;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #464c5c;
  cursor: pointer;
}
.sb-question-panel__toggle:hover {
  background: #edf0f5;
}
.sb-question-panel__toggle svg {
  transition: transform 160ms ease;
}
.sb-question-panel.is-collapsed .sb-question-panel__toggle {
  top: 12px;
}
.sb-question-panel.is-collapsed .sb-question-panel__toggle svg {
  transform: rotate(180deg);
}
.sb-question-panel__collapsed {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 56px;
  padding: 8px 48px 8px 16px;
}
.sb-question-panel__collapsed p {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #212736;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.sb-question-panel__collapsed strong {
  font-weight: 600;
}
.sb-question-panel__muted {
  color: #646e82;
}
.sb-question-panel__collapsed .sb-question-button {
  height: 36px;
}
.sb-choice-card__header {
  padding: 14px 48px 0 16px;
}
.sb-choice-card__question {
  margin: 0;
  color: #212736;
  font-size: 17px;
  font-weight: 600;
  line-height: 24px;
}
.sb-choice-card__hint {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #646e82;
  font-size: 13px;
  line-height: 18px;
}
.sb-choice-card__chip {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 4px;
  background: #edf0f5;
  color: #464c5c;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}
.sb-choice-card__body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 16px 16px;
}
.sb-choice-card__options {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.sb-choice-card__options--palette {
  display: grid;
  grid-template-columns: repeat(var(--sb-choice-columns, 3), minmax(0, 1fr));
  gap: 12px;
}
.sb-choice-card__options--visual {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.sb-choice-card__options--fonts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
.sb-choice-card__option {
  position: relative;
  display: flex;
  border-radius: 10px;
  background: #f7f8fa;
  transition: background 150ms ease;
}
.sb-choice-card__option:hover {
  background: #eff1f4;
}
.sb-choice-card__option.is-selected {
  background: #eff4ff;
}
.sb-choice-card__option.is-selected:hover {
  background: #e4ecff;
}
.sb-choice-card__option:has(input:focus-visible) {
  outline: 3px solid #9ebbff;
  outline-offset: 2px;
}
.sb-choice-card__option:has(input:disabled) {
  opacity: 0.6;
}
.sb-choice-card__options--palette .sb-choice-card__option,
.sb-choice-card__options--visual .sb-choice-card__option,
.sb-choice-card__options--fonts .sb-choice-card__option {
  border-radius: 12px;
}
.sb-choice-card__label {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  cursor: pointer;
}
.sb-choice-card__option:has(input:disabled) .sb-choice-card__label {
  cursor: default;
}
.sb-choice-card__row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 9px 12px;
}
.sb-choice-card__row > input {
  margin-top: 1px;
}
/* An option without a description centres its control on the title. */
.sb-choice-card__row:not(:has(.sb-choice-card__description)) {
  align-items: center;
}
.sb-choice-card__row:not(:has(.sb-choice-card__description)) > input {
  margin-top: 0;
}
.sb-choice-card__row:not(:has(.sb-choice-card__description)) .sb-choice-card__title {
  font-weight: 500;
}
.sb-choice-card__options--list .has-flag .sb-choice-card__row {
  padding-right: 46px;
}
.sb-choice-card__options--palette .sb-choice-card__row {
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
}
.sb-choice-card__options--palette .sb-choice-card__row > input {
  margin-top: 0;
}
.sb-choice-card__options--visual .sb-choice-card__row {
  padding: 10px 12px 12px;
}
.sb-choice-card__copy {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.sb-choice-card__title {
  color: #111e39;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
}
.sb-choice-card__description {
  color: #858585;
  font-size: 13px;
  line-height: 18px;
}
.sb-choice-card__swatches {
  display: flex;
  flex: 0 0 96px;
  height: 40px;
  overflow: hidden;
  border: 1px solid #d5dae3;
  border-radius: 8px;
}
.sb-choice-card__options--palette .sb-choice-card__swatches {
  flex: 1 1 auto;
  height: 48px;
}
.sb-choice-card__swatch {
  flex: 1 1 0;
}
.sb-choice-card__swatch + .sb-choice-card__swatch {
  box-shadow: inset 1px 0 0 rgba(33, 39, 54, 0.12);
}
.sb-choice-card__visual {
  display: block;
  height: 88px;
  margin: 8px 8px 0;
  overflow: hidden;
  border-radius: 8px;
  background: #f3f6ff;
}
.sb-choice-card__visual--fonts {
  height: auto;
  background: transparent;
}
.sb-design-preview {
  display: block;
  width: 100%;
  height: 100%;
}
/* Controls: a ring with a dot, a rounded square with a round-capped tick. */
.sb-question-panel input[type='radio'],
.sb-question-panel input[type='checkbox'] {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin: 0;
  border: 1.5px solid #8c94a6;
  background: #fff;
  cursor: pointer;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
}
.sb-question-panel input[type='radio'] {
  border-radius: 50%;
}
.sb-question-panel input[type='checkbox'] {
  border-radius: 6px;
}
.sb-question-panel input[type='radio']:checked {
  border-color: #165bfb;
  background: #165bfb;
  box-shadow: inset 0 0 0 3.5px #fff;
}
.sb-question-panel input[type='checkbox']:checked {
  border-color: #165bfb;
  background: #165bfb
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    center / 14px 14px no-repeat;
}
.sb-question-panel input[type='radio']:focus-visible,
.sb-question-panel input[type='checkbox']:focus-visible {
  outline: none;
}
.sb-question-panel input:disabled {
  cursor: default;
}
.sb-choice-card__option--own {
  align-items: center;
  gap: 10px;
  padding: 2px 12px;
}
.sb-choice-card__own-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 36px;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: #212736;
  font: inherit;
  font-size: 15px;
  line-height: 20px;
}
.sb-choice-card__own-input::-moz-placeholder {
  color: #646e82;
}
.sb-choice-card__own-input::placeholder {
  color: #646e82;
}
/* The tradeoff note of an option: a yellow badge with a dark tip. */
.sb-choice-card__flag {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid #f5c451;
  border-radius: 13px;
  background: #ffe7b0;
  color: #7a4d00;
  box-shadow:
    0 0 0 2px #fff,
    0 2px 6px rgba(33, 39, 54, 0.18);
  cursor: pointer;
}
.sb-choice-card__flag:hover {
  background: #ffda8a;
}
.sb-choice-card__flag:focus-visible {
  outline: 3px solid #9ebbff;
  outline-offset: 1px;
}
.sb-choice-card__options--list .sb-choice-card__flag {
  top: 9px;
  right: 10px;
}
.sb-choice-card__tip {
  position: absolute;
  top: calc(100% + 10px);
  right: -10px;
  z-index: 30;
  display: none;
  width: 280px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #212736;
  box-shadow: 0 8px 24px rgba(33, 39, 54, 0.24);
  color: #fff;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  white-space: normal;
  cursor: default;
}
.sb-choice-card__tip::after {
  content: '';
  position: absolute;
  right: 18px;
  bottom: 100%;
  border: 6px solid transparent;
  border-bottom-color: #212736;
}
.sb-choice-card__flag:hover .sb-choice-card__tip,
.sb-choice-card__flag:focus-visible .sb-choice-card__tip,
.sb-choice-card__flag.is-open .sb-choice-card__tip {
  display: block;
}
.sb-choice-card__footer,
.sb-survey__footer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px 12px 16px;
}
.sb-choice-card__footer {
  justify-content: flex-end;
}
.sb-question-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border: 0;
  border-radius: 8px;
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background 150ms ease,
    color 150ms ease;
}
.sb-question-button:focus-visible {
  outline: 3px solid #9ebbff;
  outline-offset: 2px;
}
.sb-question-button--primary {
  background: #165bfb;
  color: #fff;
}
.sb-question-button--primary:hover:not(:disabled) {
  background: #1348c2;
}
.sb-question-button--primary:disabled {
  background: #edf0f5;
  color: #9199ab;
  cursor: not-allowed;
}
.sb-question-button--ghost {
  background: transparent;
  color: #464c5c;
}
.sb-question-button--ghost:hover:not(:disabled) {
  background: #edf0f5;
  color: #212736;
}
.sb-question-button--ghost:disabled {
  color: #b4bccb;
  cursor: not-allowed;
}
.sb-survey__question:focus {
  outline: none;
}
.sb-survey__text {
  display: block;
  width: 100%;
  min-height: 84px;
  padding: 10px 12px;
  resize: vertical;
  border: 0;
  border-radius: 10px;
  outline: none;
  background: #f7f8fa;
  color: #212736;
  font: inherit;
  font-size: 15px;
  line-height: 20px;
}
.sb-survey__text::-moz-placeholder {
  color: #646e82;
}
.sb-survey__text::placeholder {
  color: #646e82;
}
.sb-survey__text:focus-visible {
  outline: 3px solid #9ebbff;
  outline-offset: 2px;
}
.sb-survey__nav {
  position: relative;
  display: flex;
  align-items: center;
  gap: 2px;
}
.sb-survey__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.sb-survey__arrow {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #646e82;
  cursor: pointer;
}
.sb-survey__arrow:hover:not(:disabled) {
  background: #edf0f5;
  color: #212736;
}
.sb-survey__arrow:disabled {
  color: #c8ceda;
  cursor: not-allowed;
}
.sb-survey__counter {
  height: 36px;
  padding: 0 8px 0 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #464c5c;
  font: inherit;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;
}
.sb-survey__counter:hover:not(:disabled),
.sb-survey__counter[aria-expanded='true'] {
  background: #edf0f5;
  color: #212736;
}
.sb-survey__arrow:focus-visible,
.sb-survey__counter:focus-visible,
.sb-survey__list-item:focus-visible,
.sb-question-panel__toggle:focus-visible {
  outline: 3px solid #9ebbff;
  outline-offset: 2px;
}
.sb-survey__list {
  position: absolute;
  bottom: calc(100% + 14px);
  left: -8px;
  z-index: 30;
  width: 440px;
  max-width: calc(100vw - 32px);
  max-height: 480px;
  overflow: auto;
  padding: 8px;
  border: 1px solid #dfe2e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 12px 32px rgba(33, 39, 54, 0.16);
}
.sb-survey__list-head {
  display: flex;
  justify-content: space-between;
  padding: 6px 8px 8px;
  color: #646e82;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}
.sb-survey__list ol {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.sb-survey__list-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 8px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #212736;
  font: inherit;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  cursor: pointer;
}
.sb-survey__list-item:hover {
  background: #f7f8fa;
}
.sb-survey__list-item.is-current {
  background: #eff4ff;
}
.sb-survey__list-number {
  display: flex;
  flex: 0 0 22px;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-top: -1px;
  border-radius: 11px;
  background: #edf0f5;
  color: #464c5c;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}
.sb-survey__list-item.is-done .sb-survey__list-number {
  background: #dee8ff;
  color: #1348c2;
}
.sb-survey__list-item.is-current .sb-survey__list-number {
  background: #165bfb;
  color: #fff;
}
.sb-survey__list-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.sb-survey__list-question {
  font-weight: 600;
}
.sb-survey__list-status {
  overflow: hidden;
  color: #646e82;
  font-size: 13px;
  line-height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.sb-survey__list-item.is-done .sb-survey__list-status {
  color: #464c5c;
}
@media (max-width: 600px) {
  .sb-question-panel__toggle {
    top: 12px;
    right: 4px;
  }
  .sb-choice-card__header {
    padding: 12px 40px 0 12px;
  }
  .sb-choice-card__question {
    font-size: 16px;
    line-height: 22px;
  }
  .sb-choice-card__body {
    padding: 10px 12px 12px;
  }
  .sb-choice-card__options--visual {
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }
  .sb-choice-card__options--visual .sb-choice-card__label {
    flex-direction: row;
    align-items: stretch;
  }
  .sb-choice-card__options--visual .sb-choice-card__visual {
    flex: 0 0 96px;
    width: 96px;
    height: auto;
    min-height: 72px;
    margin: 8px 0 8px 8px;
  }
  .sb-choice-card__options--visual .sb-choice-card__flag {
    top: 12px;
    right: auto;
    left: 70px;
  }
  .sb-choice-card__options--visual .sb-choice-card__tip {
    right: auto;
    left: -10px;
    width: 250px;
  }
  .sb-choice-card__options--visual .sb-choice-card__tip::after {
    right: auto;
    left: 18px;
  }
  .sb-choice-card__options--palette {
    gap: 8px;
  }
  .sb-choice-card__options--palette .sb-choice-card__row {
    gap: 6px;
    padding: 10px 8px;
  }
  .sb-choice-card__options--palette .sb-choice-card__swatches {
    height: 40px;
  }
  .sb-choice-card__options--fonts {
    grid-template-columns: minmax(0, 1fr);
  }
  .sb-choice-card__footer,
  .sb-survey__footer {
    flex-wrap: wrap;
    padding: 0 12px 12px;
  }
  .sb-choice-card__footer,
  .sb-survey__actions {
    display: grid;
    grid-auto-columns: minmax(0, 1fr);
    grid-auto-flow: column;
    width: 100%;
    margin-left: 0;
  }
  .sb-survey__nav {
    justify-content: center;
    width: 100%;
  }
  .sb-survey__arrow {
    width: 44px;
    height: 44px;
  }
  .sb-survey__counter {
    height: 44px;
  }
  .sb-survey__list {
    left: 0;
  }
  .sb-question-button {
    width: 100%;
    height: 44px;
  }
  .sb-question-panel__collapsed .sb-question-button {
    width: auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  .sb-choice-card__option,
  .sb-question-button,
  .sb-question-panel__toggle svg {
    transition: none;
  }
}
/* The temporarily hidden typography cards and constructors keep their own pieces. */
.sb-font-specimen {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border: 1px solid #e3e9f6;
  border-radius: 10px;
  background: #fff;
}
.sb-font-specimen__aa {
  flex: 0 0 auto;
  color: #263654;
  font-size: 30px;
  line-height: 1;
}
.sb-font-specimen__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}
.sb-font-specimen__heading {
  color: #1f2e49;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.25;
}
.sb-font-specimen__body {
  color: #596983;
  font-size: 12px;
  line-height: 1.45;
}
.sb-palette-ctor,
.sb-font-ctor {
  display: grid;
  gap: 12px;
  padding: 12px;
  border: 1px solid #cbdcff;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.82);
}
.sb-palette-ctor__strip {
  display: flex;
  height: 38px;
  overflow: hidden;
  border: 1px solid #dbe4f7;
  border-radius: 10px;
}
.sb-palette-ctor__strip i {
  flex: 1;
}
.sb-palette-ctor fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
.sb-palette-ctor legend {
  margin-bottom: 6px;
  padding: 0;
  color: #44546e;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.sb-palette-ctor__row,
.sb-font-ctor__row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.sb-palette-ctor__row:has(> :only-child) {
  grid-template-columns: minmax(0, 1fr);
}
.sb-palette-ctor__field label,
.sb-font-ctor__field label {
  display: block;
  margin-bottom: 4px;
  color: #596983;
  font-size: 12px;
  font-weight: 600;
}
.sb-palette-ctor__input {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  border: 1px solid #d9e3f5;
  border-radius: 9px;
  background: #fff;
}
.sb-palette-ctor__input input[type='color'] {
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: none;
  cursor: pointer;
}
.sb-palette-ctor__input input[type='text'] {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  color: #27344a;
  font: inherit;
  font-size: 13px;
  text-transform: uppercase;
}
.sb-palette-ctor__input:focus-within,
.sb-font-ctor__field select:focus {
  border-color: #668eff;
  box-shadow: 0 0 0 3px rgba(75, 124, 255, 0.11);
}
.sb-palette-ctor__hint,
.sb-font-ctor__note {
  margin: 0;
  color: #8a5a2b;
  font-size: 12px;
  line-height: 1.45;
}
.sb-font-ctor__field select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #d9e3f5;
  border-radius: 9px;
  outline: none;
  background: #fff;
  color: #27344a;
  font: inherit;
  font-size: 13px;
}
@media (max-width: 560px) {
  .sb-palette-ctor__row,
  .sb-font-ctor__row {
    grid-template-columns: minmax(0, 1fr);
  }
}
/* The wow played when the boldest creativity level is chosen (see utils/creativeBoom.ts). */
.sb-boom-canvas {
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
}
.sb-boom-wow {
  position: fixed;
  top: 150px;
  left: 50%;
  z-index: 2147483001;
  display: grid;
  width: 180px;
  height: 150px;
  margin-left: -90px;
  place-items: center;
  pointer-events: none;
  animation:
    sb-boom-wow-in 600ms cubic-bezier(0.2, 1.7, 0.4, 1) both,
    sb-boom-wow-out 400ms ease 2s forwards;
}
.sb-boom-wow::before {
  content: '';
  position: absolute;
  inset: 0;
  background: #ffd23f;
  clip-path: polygon(
    50% 0,
    60% 22%,
    84% 8%,
    76% 34%,
    100% 40%,
    80% 58%,
    96% 82%,
    70% 76%,
    62% 100%,
    50% 80%,
    38% 100%,
    30% 76%,
    4% 82%,
    20% 58%,
    0 40%,
    24% 34%,
    16% 8%,
    40% 22%
  );
  animation: sb-boom-spin 6s linear infinite;
}
.sb-boom-wow b {
  position: relative;
  color: #7a2cff;
  font:
    900 34px Inter,
    system-ui,
    sans-serif;
  letter-spacing: 0.04em;
  text-shadow: 2px 2px 0 #fff;
  transform: rotate(-8deg);
}
.sb-boom-rocket {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2147483001;
  font-size: 46px;
  line-height: 1;
  pointer-events: none;
  filter: drop-shadow(0 8px 10px rgba(60, 30, 120, 0.35));
  will-change: transform;
}
@keyframes sb-boom-wow-in {
  from {
    transform: scale(0) rotate(-30deg);
  }
  to {
    transform: scale(1) rotate(0);
  }
}
@keyframes sb-boom-wow-out {
  to {
    opacity: 0;
    transform: translateY(-22px) scale(0.92);
  }
}
@keyframes sb-boom-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .sb-boom-canvas,
  .sb-boom-wow,
  .sb-boom-rocket {
    display: none;
  }
}
.sb-working {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 0;
  color: #7d8ba4;
}
.sb-working strong {
  font-size: 10px;
  font-weight: 500;
}
.sb-working p {
  font-size: 9px;
  color: #9ba6b9;
  margin-top: 4px;
}
.sb-thinking {
  display: flex;
  gap: 3px;
  margin-left: auto;
}
.sb-thinking i {
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background: #96b0e0;
  animation: sb-think 1.4s infinite;
}
.sb-thinking i:nth-child(2) {
  animation-delay: 0.2s;
}
.sb-thinking i:nth-child(3) {
  animation-delay: 0.4s;
}
.sb-composer-area {
  padding: 15px 26px 17px;
  background: #fcfdff;
}
.sb-composer {
  border: 1px solid #dce4f3;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 14px #384c7404;
  padding: 13px 14px 9px;
}
.sb-composer:focus-within {
  border-color: #98b8fa;
  box-shadow: 0 0 0 3px #165bfb05;
}
/* Continue chat from the sidebar draws the eye back to the message box. */
.sb-composer.is-called {
  border-color: #165bfb;
  animation: sb-composer-call 1.4s ease-out;
}
@keyframes sb-composer-call {
  0% { box-shadow: 0 0 0 0 #165bfb55; }
  70% { box-shadow: 0 0 0 10px #165bfb00; }
  100% { box-shadow: 0 0 0 0 #165bfb00; }
}
@media (prefers-reduced-motion: reduce) {
  .sb-composer.is-called { animation: none; }
}
.sb-composer.is-disabled {
  background: #f9fafd;
}
.sb-composer textarea {
  border: none;
  outline: none;
  resize: vertical;
  min-height: 50px;
  max-height: 160px;
  width: 100%;
  font-size: 12px;
  line-height: 1.8;
  background: transparent;
  color: var(--sb-ink);
}
.sb-composer textarea::-moz-placeholder {
  color: #a0abbd;
}
.sb-composer textarea::placeholder {
  color: #a0abbd;
}
.sb-composer-bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.sb-composer-bottom > span {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #a0aabc;
  font-size: 8px;
}
.sb-composer-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}
.sb-composer-actions .sb-button {
  min-height: 34px;
  padding: 8px 12px;
  gap: 6px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
  transition:
    background 0.15s,
    border-color 0.15s,
    color 0.15s,
    box-shadow 0.15s;
}
.sb-composer-actions .sb-button > svg,
.sb-composer-actions .sb-spinner {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}
.sb-composer-actions .sb-button-secondary {
  background: #f5f7fb;
  border-color: #e8ecf4;
  color: #5d6b82;
}
.sb-composer-actions .sb-button-secondary:hover:not(:disabled) {
  background: #edf3ff;
  border-color: #d6e3fd;
  color: var(--sb-blue);
}
.sb-composer-actions .sb-button-primary {
  box-shadow: 0 1px 2px #165bfb14;
}
.sb-composer-actions .sb-button-primary:hover:not(:disabled) {
  box-shadow: 0 2px 6px #165bfb25;
}
.sb-composer-actions .sb-button:disabled {
  opacity: 1;
  background: #f1f4f9;
  border-color: #e8ecf2;
  color: #9aa6b9;
  box-shadow: none;
}
.sb-composer-hint {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  color: #a8b1c0;
  font-size: 8px;
  padding: 10px 2px 0;
}
.sb-chat-stage-note {
  display: flex;
  gap: 9px;
  align-items: flex-start;
  color: #8897ae;
  padding: 0 0 12px;
  font-size: 10px;
  line-height: 1.7;
}
.sb-chat-stage-note svg {
  flex-shrink: 0;
}
.sb-details {
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
  border-left: 1px solid var(--sb-line);
  background: white;
  padding: 23px 21px 0;
}
/* Until Evo finishes the interview the chat takes the whole width. */
.sb-workspace-columns.sb-without-details {
  grid-template-columns: minmax(300px, 1fr);
}
.sb-details-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 0 18px;
  border-top: 1px solid var(--sb-line);
}
.sb-details-actions .sb-button {
  flex: 1 1 140px;
  justify-content: center;
}
.sb-details-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 21px;
}
.sb-icon-tile {
  display: grid;
  place-items: center;
  color: #7690b7;
  width: 34px;
  height: 35px;
  border-radius: 9px;
  background: #f3f6fb;
}
.sb-details-heading h2 {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.2px;
}
.sb-details-heading p {
  font-size: 9px;
  margin-top: 5px;
  color: #9aa5b7;
}
.sb-stage-card {
  padding: 17px;
  border: 1px solid #e2eafb;
  background: linear-gradient(135deg, #f6f9ff, #f9faff);
  border-radius: 12px;
  margin-bottom: 21px;
}
.sb-stage-card .sb-eyebrow {
  display: flex;
  justify-content: space-between;
  color: #8ca0c4;
  font-size: 7px;
}
.sb-stage-card .sb-eyebrow > span {
  letter-spacing: 0.4px;
}
.sb-stage-card h3 {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.4px;
  margin: 11px 0 9px;
}
.sb-stage-card p {
  color: #8b9ab2;
  font-size: 10px;
  line-height: 1.8;
  margin-bottom: 15px;
}
.sb-stage-card .sb-button {
  min-height: 36px;
  padding: 9px 11px;
  font-size: 10px;
}
.sb-stage-card .sb-button > svg:last-child {
  margin-left: auto;
}
.sb-text-button {
  background: none;
  border: none;
  color: var(--sb-blue);
  font-size: 10px;
  font-weight: 500;
  padding: 10px 0;
  text-decoration: none;
}
.sb-panel-tabs {
  display: flex;
  gap: 21px;
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 1px solid var(--sb-line);
  flex-shrink: 0;
}
.sb-panel-tabs > button {
  position: relative;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 2px 0 12px;
  border: none;
  background: none;
  color: #9aa6b8;
  font-size: 10px;
  white-space: nowrap;
}
.sb-panel-tabs > button.is-active {
  color: var(--sb-blue);
  font-weight: 600;
}
.sb-panel-tabs > button.is-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--sb-blue);
  border-radius: 3px;
}
.sb-panel-tabs > button > span {
  font-size: 8px;
  background: #edf3ff;
  color: #7897cc;
  border-radius: 4px;
  padding: 1px 4px;
}
.sb-panel-body {
  min-height: 0;
  flex: 1;
  overflow-y: auto;
  padding: 19px 1px 22px;
  overscroll-behavior: contain;
}
.sb-panel-caption {
  display: flex;
  justify-content: space-between;
  gap: 7px;
  align-items: center;
  margin-bottom: 14px;
  font-size: 7px;
  color: #9ba8bc;
  letter-spacing: 0.9px;
}
.sb-panel-caption > span:last-child:not(.sb-saved-dot) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 55%;
  letter-spacing: 0;
}
.sb-saved-dot {
  display: flex;
  align-items: center;
  gap: 4px;
  letter-spacing: 0;
  font-size: 8px;
  color: #83a594;
}
.sb-saved-dot::before {
  content: '';
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background: #8cb8a2;
}
.sb-panel-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #a7b6cd;
  padding: 34px 12px;
  border: 1px dashed #e2e8f2;
  border-radius: 11px;
  background: #fbfcff;
}
.sb-panel-empty h3 {
  font-size: 12px;
  color: #7e91ad;
  margin-top: 14px;
  font-weight: 500;
}
.sb-panel-empty p {
  font-size: 10px;
  color: #a0aec1;
  line-height: 1.9;
  margin-top: 9px;
  max-width: 230px;
}
.sb-brief-requirements .sb-requirement-text {
  margin: 0;
}
.sb-requirement details {
  margin-top: 4px;
}
.sb-requirement summary {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #95a4ba;
  font-size: 10px;
  list-style: none;
}
.sb-requirement summary > svg {
  flex-shrink: 0;
  color: #a9b7cb;
  transition: transform 0.15s;
}
.sb-requirement details[open] summary > svg {
  transform: rotate(90deg);
}
.sb-assumption {
  display: inline-block;
  margin-left: 6px;
  font-size: 9px;
  background: #faf6ed;
  color: #ae976f;
  padding: 3px 5px;
  border-radius: 4px;
}
.sb-requirement-value {
  white-space: pre-line;
}
.sb-brief-summary {
  color: #4e6384;
  font-size: 13px;
  line-height: 1.65;
  overflow-wrap: anywhere;
}
.sb-brief-summary p {
  margin: 0 0 14px;
  white-space: pre-line;
}
.sb-brief-summary h3 {
  margin: 20px 0 8px;
  color: #253653;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.4;
}
.sb-brief-summary > :first-child {
  margin-top: 0;
}
.sb-brief-summary ul {
  display: grid;
  gap: 8px;
  margin: 0;
  padding-left: 18px;
  list-style: disc;
}
.sb-brief-summary li {
  padding-left: 2px;
}
.sb-brief-summary li::marker {
  color: #a0aec2;
}
.sb-brief-summary strong {
  color: #344663;
  font-weight: 600;
}
.sb-value-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.sb-value-list > div {
  padding: 2px 6px;
  background: #f2f5fa;
  border-radius: 4px;
}
.sb-value-fields > div {
  margin-bottom: 6px;
}
.sb-value-fields dt {
  color: #9ba7b9;
  font-size: 8px;
}
.sb-value-fields dd {
  margin: 0;
}
.sb-requirement-context {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid #edf1f6;
  color: #9aa9be;
  font-size: 9px;
  line-height: 1.7;
}
.sb-requirement-context p {
  margin-bottom: 7px;
}
.sb-requirement-context blockquote {
  font-style: italic;
  padding-left: 7px;
  border-left: 2px solid #dce8fc;
  margin: 8px 0;
}
.sb-requirement-context > span {
  display: block;
  font-size: 8px;
}
.sb-original-idea {
  margin: 18px 1px;
  padding-top: 12px;
  border-top: 1px solid var(--sb-line);
  color: #9aa8bc;
  font-size: 9px;
}
.sb-original-idea summary {
  cursor: pointer;
}
.sb-original-idea p {
  font-size: 10px;
  line-height: 1.9;
  margin-top: 10px;
  white-space: pre-wrap;
}
.sb-palette {
  display: flex;
  height: 17px;
  overflow: hidden;
  border-radius: 5px;
  border: 1px solid #e2e8f2;
  margin: 15px 0 20px;
}
.sb-palette span {
  flex: 1;
}
.sb-plan-page {
  margin-bottom: 10px;
  border: 1px solid #e5ebf5;
  border-radius: 9px;
  padding: 12px;
}
.sb-plan-page summary {
  display: flex;
  gap: 8px;
  align-items: center;
  color: #6b80a0;
  font-size: 10px;
  cursor: pointer;
}
.sb-plan-page summary > span {
  flex: 1;
  overflow-wrap: anywhere;
}
.sb-plan-page summary small {
  color: #9dacbf;
  font-size: 8px;
}
.sb-plan-page ol {
  list-style: none;
  margin: 13px 0 0 7px;
  padding: 0 0 0 14px;
  border-left: 1px solid #e4ebf7;
}
.sb-plan-page li {
  position: relative;
  font-size: 9px;
  color: #94a3ba;
  padding: 5px 0;
}
.sb-plan-page li > span {
  position: absolute;
  width: 5px;
  height: 5px;
  background: #dae5f5;
  border-radius: 100%;
  left: -17px;
  top: 9px;
}
.sb-shared-sections {
  padding: 17px 10px;
}
.sb-shared-sections p {
  color: #9aa8bc;
  font-size: 10px;
  margin-top: 10px;
}
.sb-creation {
  text-align: center;
  padding-top: 6px;
}
.sb-site-symbol {
  display: inline-grid;
  place-items: center;
  width: 70px;
  height: 70px;
  background: #f1f6ff;
  border: 1px solid #e3edfe;
  border-radius: 18px;
  color: #739cda;
  margin-bottom: 15px;
}
.sb-creation h3 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  overflow-wrap: anywhere;
}
.sb-creation > .sb-status-pill {
  margin-bottom: 25px;
}
.sb-build-stat {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 11px 0;
  border-bottom: 1px solid #edf1f7;
  font-size: 9px;
  color: #9aa9bd;
}
.sb-build-stat strong {
  color: #6d86aa;
  font-weight: 500;
}
.sb-creation progress {
  width: 100%;
  height: 5px;
  accent-color: var(--sb-blue);
  border: none;
  border-radius: 8px;
  overflow: hidden;
  margin: 13px 0;
}
.sb-creation progress::-webkit-progress-bar {
  background: #edf2fa;
}
.sb-creation progress::-webkit-progress-value {
  background: var(--sb-blue);
  border-radius: 8px;
}
.sb-website-id {
  text-align: left;
  padding: 13px 10px 0;
  border: 1px solid #e7edf6;
  border-radius: 8px;
  margin-top: 15px;
}
.sb-website-id code {
  display: block;
  font-size: 10px;
  color: #8094b2;
  margin-top: 8px;
  overflow-wrap: anywhere;
}
.sb-deferred {
  text-align: left;
  border-top: 1px solid #e7edf6;
  padding: 17px 0;
  margin-top: 20px;
}
.sb-deferred h4 {
  font-size: 11px;
  color: #8f7d62;
}
.sb-deferred p {
  font-size: 10px;
  color: #a99d89;
  line-height: 1.8;
  margin-top: 5px;
}
.sb-deferred > div {
  padding: 12px;
  border: 1px solid #f1eade;
  border-radius: 8px;
  margin-top: 10px;
}
.sb-deferred strong {
  font-size: 10px;
  color: #958265;
  font-weight: 500;
}
.sb-error,
.sb-notice {
  background: #fff8f5;
  border: 1px solid #f2dfd6;
  color: #ae735c;
  padding: 12px 14px;
  font-size: 11px;
  line-height: 1.8;
  border-radius: 9px;
  white-space: pre-line;
  margin: 7px 0 12px;
  overflow-wrap: anywhere;
}
.sb-workspace-alert {
  flex-shrink: 0;
  max-height: 160px;
  overflow-y: auto;
  padding: 10px 25px;
  background: #fff8f5;
  border-bottom: 1px solid #f2dfd6;
  color: #ae735c;
  font-size: 11px;
  line-height: 1.8;
  white-space: pre-line;
  overflow-wrap: anywhere;
}
.sb-workspace-alert > button {
  display: block;
}
.sb-sync-error {
  background: #fffbef;
  border-bottom: 1px solid #f3ead4;
  color: #a18c62;
  padding: 10px 20px;
  font-size: 10px;
}
.sb-sync-error button {
  border: none;
  background: none;
  text-decoration: underline;
  margin-left: 6px;
}
.sb-ready {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  color: #6d9f86;
}
.sb-muted {
  color: var(--sb-muted);
}
.sb-spinner {
  display: inline-block;
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  border: 1.5px solid currentColor;
  border-right-color: transparent;
  border-radius: 100%;
  animation: sb-spin 0.8s linear infinite;
}
.sb-workspace-loading {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
  height: 100%;
  color: #8b9db9;
  font-size: 12px;
}
.sb-workspace-loading h2 {
  font-size: 20px;
  color: #5b7397;
}
.sb-mobile-tabs,
.sb-sessions-toggle {
  display: none;
}
@keyframes sb-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes sb-think {
  0%,
  60%,
  100% {
    opacity: 0.3;
  }
  30% {
    opacity: 1;
  }
}
@media (min-width: 1650px) {
  .sb-workspace-columns {
    grid-template-columns: minmax(300px, 1fr) 390px;
  }
  .sb-messages {
    padding: 25px 48px;
  }
  .sb-composer-area {
    padding-left: 40px;
    padding-right: 40px;
  }
  .sb-details {
    padding-left: 28px;
    padding-right: 28px;
  }
}
@media (max-width: 1250px) {
  .sb-sidebar {
    flex-basis: 222px;
    padding-left: 13px;
    padding-right: 13px;
  }
  .sb-workspace-columns {
    grid-template-columns: minmax(280px, 1fr) 305px;
  }
  .sb-details {
    padding: 19px 17px 0;
  }
  .sb-new-site {
    padding: 35px;
  }
  .sb-idea-art {
    transform: scale(0.9);
    transform-origin: right center;
    width: 260px;
  }
  .sb-text-only {
    display: none;
  }
}
@media (max-width: 1050px) {
  .sb-sidebar {
    flex-basis: 205px;
  }
  .sb-sidebar-title {
    margin-left: 0;
    margin-right: 0;
    gap: 7px;
  }
  .sb-sidebar-title strong {
    font-size: 14px;
  }
  .sb-mobile-tabs {
    display: flex;
    flex-shrink: 0;
    background: white;
    border-bottom: 1px solid var(--sb-line);
    padding: 0 25px;
    gap: 20px;
  }
  .sb-mobile-tabs > button {
    display: flex;
    align-items: center;
    gap: 7px;
    border: none;
    background: none;
    padding: 12px 0;
    font-size: 11px;
    color: #9aa7bd;
  }
  .sb-mobile-tabs > button.is-active {
    color: var(--sb-blue);
    box-shadow: 0 2px var(--sb-blue);
  }
  .sb-workspace-columns {
    grid-template-columns: minmax(0, 1fr);
  }
  .sb-show-chat > .sb-details,
  .sb-show-details > .sb-conversation {
    display: none;
  }
  .sb-show-details > .sb-details {
    border: none;
    padding: 22px 26px 0;
  }
  .sb-stage-card {
    flex-shrink: 0;
  }
  .sb-new-site {
    padding: 32px;
    gap: 22px 0;
  }
  .sb-idea-art {
    transform: scale(0.7);
    width: 200px;
  }
  .sb-new-intro h1 {
    font-size: 34px;
  }
  .sb-kicker {
    font-size: 7px;
    letter-spacing: 0.8px;
  }
  .sb-desktop-break {
    display: none;
  }
  .sb-idea-options .sb-button {
    margin-left: auto;
  }
}
@media (max-width: 750px) {
  .sb-app {
    flex-direction: column;
    position: relative;
  }
  .sb-global-header nav {
    gap: 0;
  }
  .sb-global-header nav a {
    font-size: 11px;
    padding: 7px 8px;
  }
  .sb-global-header > div {
    min-height: 70px;
  }
  .sb-sessions-toggle {
    display: flex;
    align-items: center;
    gap: 9px;
    flex-shrink: 0;
    padding: 13px 20px;
    background: white;
    border: none;
    border-bottom: 1px solid var(--sb-line);
    color: #7588a4;
    font-size: 11px;
  }
  .sb-sessions-toggle > svg:last-child {
    margin-left: auto;
    transform: rotate(90deg);
  }
  .sb-sidebar {
    display: none;
  }
  .sb-sidebar.is-open {
    display: flex;
    position: absolute;
    z-index: 10;
    top: 44px;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 22px;
    box-shadow: 0 10px 30px #26446e13;
  }
  .sb-sidebar-footer {
    max-width: 420px;
  }
  .sb-sidebar-title {
    margin-bottom: 16px;
  }
  .sb-main {
    width: 100%;
  }
  .sb-new-site {
    padding: 30px 23px;
    grid-template-columns: 1fr;
    gap: 24px;
    min-height: 100%;
    align-content: start;
  }
  .sb-new-intro {
    text-align: center;
  }
  .sb-new-intro h1 {
    font-size: 36px;
    margin-top: 15px;
    letter-spacing: -1.6px;
  }
  .sb-new-intro p {
    font-size: 11px;
  }
  .sb-kicker {
    font-size: 6px;
    letter-spacing: 0.9px;
  }
  .sb-idea-art {
    display: none;
  }
  .sb-idea-form {
    padding: 20px 17px 15px;
    border-radius: 12px;
  }
  .sb-idea-form > textarea {
    font-size: 11px;
    min-height: 115px;
  }
  .sb-idea-options {
    gap: 13px 8px;
  }
  .sb-session-name {
    min-width: calc(100% - 90px);
  }
  .sb-idea-options .sb-button {
    width: 100%;
  }
  .sb-idea-starters > div {
    gap: 7px;
  }
  .sb-idea-starters button {
    padding: 12px 10px;
  }
  .sb-idea-starters strong {
    font-size: 10px;
    line-height: 1.5;
  }
  .sb-idea-starters p {
    font-size: 8px;
  }
  .sb-idea-starters button > svg {
    display: none;
  }
  .sb-new-footnote {
    gap: 7px;
    font-size: 7px;
    margin-top: 0;
  }
  .sb-new-footnote i {
    width: 12px;
  }
  .sb-workspace-header {
    padding: 18px 20px 15px;
    gap: 7px;
  }
  .sb-workspace-header h1 {
    font-size: 18px;
  }
  .sb-workspace-header-actions {
    gap: 6px;
  }
  .sb-status-pill {
    font-size: 8px;
  }
  .sb-steps {
    padding: 0 20px 16px;
    gap: 5px;
    overflow-x: auto;
  }
  .sb-steps li {
    font-size: 8px;
    gap: 4px;
  }
  .sb-steps li > span {
    width: 15px;
    height: 15px;
    font-size: 7px;
  }
  .sb-steps li:not(:last-child)::after {
    min-width: 5px;
  }
  .sb-mobile-tabs {
    padding: 0 20px;
  }
  .sb-conversation-top {
    padding: 14px 20px;
  }
  .sb-messages {
    padding: 18px 20px;
  }
  .sb-message {
    max-width: 100%;
  }
  .sb-message-user {
    margin-left: 16px;
  }
  .sb-message-content {
    font-size: 12px;
  }
  .sb-composer-area {
    padding: 12px 15px 15px;
  }
  .sb-composer-hint {
    font-size: 7px;
  }
  .sb-composer-hint > span:last-child {
    display: none;
  }
  .sb-conversation-start {
    font-size: 6px;
    letter-spacing: 1px;
  }
}
@media (max-width: 750px) {
  .sb-message-content,
  .sb-idea-form > textarea,
  .sb-welcome-message p {
    font-size: 14px;
  }
  .sb-idea-form > textarea,
  .sb-composer textarea,
  .sb-session-name input,
  .sb-search input {
    font-size: 16px;
  }
  .sb-details-heading h2 {
    font-size: 13px;
  }
  .sb-stage-card p,
  .sb-plan-page summary,
  .sb-build-stat {
    font-size: 12px;
  }
  .sb-panel-tabs > button,
  .sb-stage-card .sb-button,
  .sb-mobile-tabs > button {
    font-size: 12px;
    min-height: 42px;
  }
  .sb-icon-button {
    width: 38px;
    height: 38px;
  }
  .sb-composer-actions {
    width: 100%;
  }
  .sb-composer-actions .sb-button {
    flex: 1;
    min-height: 42px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .sb-page *,
  .sb-page *::before,
  .sb-page *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}
.sb-build-progress {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  padding: 14px 16px;
  border: 1px solid #cbdcff;
  border-radius: 16px;
  background: linear-gradient(145deg, #f8fbff 0%, #f4f7ff 55%, #f9f5ff 100%);
}
.sb-build-progress__title {
  color: #1f2e49;
  font-size: 14px;
  font-weight: 700;
}
.sb-build-progress__steps {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.sb-build-progress__steps li {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #7a8496;
  font-size: 12px;
  font-weight: 600;
}
.sb-build-progress__mark {
  display: grid;
  width: 20px;
  height: 20px;
  place-items: center;
  border: 1px solid #ccd8ef;
  border-radius: 50%;
  background: #fff;
  color: #7a8496;
  font-size: 10px;
  font-weight: 700;
}
.sb-build-progress__steps li.is-done {
  color: #287447;
}
.sb-build-progress__steps li.is-done .sb-build-progress__mark {
  border-color: #dff4e7;
  background: #dff4e7;
  color: #287447;
}
.sb-build-progress__steps li.is-active {
  color: #1f2e49;
}
.sb-build-progress__steps li.is-active .sb-build-progress__mark {
  border: 2px solid #dce5f7;
  border-top-color: #4b7cff;
  animation: sb-build-progress-spin 0.9s linear infinite;
}
.sb-build-progress__steps li.is-failed {
  color: #b42318;
}
.sb-build-progress__steps li.is-failed .sb-build-progress__mark {
  border-color: #fde2df;
  background: #fde2df;
  color: #b42318;
}
.sb-build-progress__note {
  margin: 0;
  color: #596983;
  font-size: 12px;
}
.sb-build-progress__error {
  margin: 0;
  color: #b42318;
  font-size: 12px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}
@keyframes sb-build-progress-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .sb-build-progress__steps li.is-active .sb-build-progress__mark {
    animation: none;
  }
}

.sb-summary-editor-hint { font-size: 12px; line-height: 1.65; color: #617295; }
.sb-summary-line { display: flex; align-items: flex-start; gap: 5px; margin: 5px 0; }
.sb-summary-edit-text { flex: 1; min-width: 0; padding: 5px; margin-left: -5px; border: 0; border-radius: 5px; background: transparent; color: inherit; font: inherit; line-height: 1.7; text-align: left; white-space: pre-wrap; overflow-wrap: anywhere; cursor: text; }
.sb-summary-edit-text:hover, .sb-summary-edit-text:focus-visible { background: #f0f4ff; outline: 1px solid #dce4ff; }
.sb-summary-line-heading { margin-top: 18px; font-size: 13px; font-weight: 700; }
.sb-summary-line textarea { flex: 1; min-width: 0; width: 100%; padding: 8px; border: 1px solid #8ba7ff; border-radius: 7px; background: #fff; color: #20304f; font: inherit; line-height: 1.7; resize: vertical; }
.sb-summary-remove { border: 0; background: transparent; color: #8191ad; padding: 5px; font-size: 18px; cursor: pointer; }
.sb-summary-remove:hover, .sb-summary-remove:focus-visible { color: #b54242; }
.sb-summary-edit-tools { display: flex; flex-wrap: wrap; gap: 14px; margin: 14px 0; }
.sb-summary-edit-tools button { border: 0; padding: 3px 0; background: transparent; color: #2956db; font: inherit; font-size: 11px; cursor: pointer; }
.sb-summary-save-row { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 10px; margin: 12px 0; color: #8191ad; font-size: 10px; }
.sb-summary-editor button:disabled { cursor: default; opacity: .55; }
@media (max-width: 600px) {
  .sb-summary-edit-text { padding-top: 10px; padding-bottom: 10px; }
  .sb-summary-remove { padding: 10px; }
  .sb-summary-line textarea { font-size: 16px; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/site-brief-chat.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB;;;;;cAKY;EACZ,eAAe;AACjB;AACA;;;;EAIE,aAAa;AACf;AACA;;;EAGE,wCAAwC;AAC1C;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,OAAO;EACP,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B;;oBAEkB;AACpB;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,OAAO;EACP,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AAFA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB;;qBAEmB;AACrB;AACA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,uCAAuC;EACvC,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,OAAO;AACT;AACA;EACE,WAAW;EACX,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,OAAO;EACP,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;AACvD;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,OAAO;EACP,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;0DAC0D;AAC1D;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,0EAA0E;EAC1E,SAAS;AACX;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA,sEAAsE;AACtE;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA,4EAA4E;AAC5E;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,qBAAgB;OAAhB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,qBAAqB;EACrB;;gCAE8B;AAChC;AACA;;EAEE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AAFA;EACE,cAAc;AAChB;AACA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd;;oCAEkC;EAClC,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf;;oBAEkB;AACpB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AAFA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qCAAqC;IACrC,QAAQ;EACV;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,WAAW;IACX,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;IACR,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,qCAAqC;EACvC;EACA;;IAEE,eAAe;IACf,oBAAoB;EACtB;EACA;;IAEE,aAAa;IACb,iCAAiC;IACjC,sBAAsB;IACtB,WAAW;IACX,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,OAAO;EACT;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;;;IAGE,gBAAgB;EAClB;AACF;AACA,oFAAoF;AACpF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,qCAAqC;AACvC;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,OAAO;EACP,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;AACA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;;EAEE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE;;IAEE,qCAAqC;EACvC;AACF;AACA,4FAA4F;AAC5F;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB;;0CAEwC;AAC1C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB;;;;;;;;;;;;;;;;;;;GAmBC;EACD,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,cAAc;EACd;;;cAGY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,uDAAuD;EACvD,sBAAsB;AACxB;AACA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;;;IAGE,aAAa;EACf;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;AACA,0EAA0E;AAC1E;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE,KAAK,6BAA6B,EAAE;EACpC,MAAM,gCAAgC,EAAE;EACxC,OAAO,6BAA6B,EAAE;AACxC;AACA;EACE,yBAAyB,eAAe,EAAE;AAC5C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AAFA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB;;;;oBAIkB;AACpB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;AACtB;AACA,qEAAqE;AACrE;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,qDAAqD;EACrD,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,OAAO;EACP,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,aAAa;AACf;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;;;IAGE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,+CAA+C;EACjD;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,+CAA+C;EACjD;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,uCAAuC;IACvC,eAAe;IACf,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,gCAAgC;EAClC;EACA;IACE,qCAAqC;EACvC;EACA;;IAEE,aAAa;EACf;EACA;IACE,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,MAAM;EACR;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,uCAAuC;IACvC,cAAc;IACd,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,iCAAiC;EACnC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;EACV;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,QAAQ;IACR,cAAc;IACd,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,cAAc;EAChB;EACA;IACE,oBAAoB;IACpB,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;AACA;EACE;;;IAGE,eAAe;EACjB;EACA;;;;IAIE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;;IAGE,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,OAAO;IACP,gBAAgB;EAClB;AACF;AACA;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,gCAAgC;IAChC,sCAAsC;EACxC;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0EAA0E;AAC5E;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sDAAsD;AACxD;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,0BAA0B,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAC9E,mBAAmB,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,aAAa,EAAE;AACpF,wBAAwB,OAAO,EAAE,YAAY,EAAE,YAAY,EAAE,iBAAiB,EAAE,SAAS,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,uBAAuB,EAAE,YAAY,EAAE;AACzQ,mEAAmE,mBAAmB,EAAE,0BAA0B,EAAE;AACpH,2BAA2B,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChF,4BAA4B,OAAO,EAAE,YAAY,EAAE,WAAW,EAAE,YAAY,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAClN,qBAAqB,SAAS,EAAE,uBAAuB,EAAE,cAAc,EAAE,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE;AACzH,6DAA6D,cAAc,EAAE;AAC7E,yBAAyB,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE,cAAc,EAAE;AACpF,gCAAgC,SAAS,EAAE,cAAc,EAAE,uBAAuB,EAAE,cAAc,EAAE,aAAa,EAAE,eAAe,EAAE,eAAe,EAAE;AACrJ,uBAAuB,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE;AACxK,qCAAqC,eAAe,EAAE,YAAY,EAAE;AACpE;EACE,wBAAwB,iBAAiB,EAAE,oBAAoB,EAAE;EACjE,qBAAqB,aAAa,EAAE;EACpC,4BAA4B,eAAe,EAAE;AAC/C","sourcesContent":[".sb-page {\n  --sb-blue: #165bfb;\n  --sb-ink: #202c42;\n  --sb-muted: #7a8496;\n  --sb-line: #e8ecf2;\n  height: 100vh;\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  color: var(--sb-ink);\n  background: #f8f9fc;\n  font-family:\n    Inter,\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    sans-serif;\n  font-size: 14px;\n}\n.sb-page button,\n.sb-page input,\n.sb-page textarea,\n.sb-page select {\n  font: inherit;\n}\n.sb-page button,\n.sb-page a,\n.sb-page summary {\n  -webkit-tap-highlight-color: transparent;\n}\n.sb-page button {\n  cursor: pointer;\n}\n.sb-page button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.sb-page :focus-visible {\n  outline: 3px solid #8eb3ff;\n  outline-offset: 3px;\n}\n.sb-global-header {\n  flex-shrink: 0;\n  background: #fff;\n}\n.sb-app {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n}\n.sb-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n.sb-sidebar {\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 258px;\n  min-height: 0;\n  padding: 28px 18px 18px;\n  border-right: 1px solid var(--sb-line);\n  background: #fff;\n}\n.sb-sidebar-title {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin: 0 7px 27px;\n}\n.sb-brand-symbol {\n  display: grid;\n  place-items: center;\n  width: 37px;\n  height: 39px;\n  color: var(--sb-blue);\n  background: #edf3ff;\n  border-radius: 12px;\n}\n.sb-sidebar-title strong {\n  display: block;\n  font-size: 16px;\n  letter-spacing: -0.4px;\n}\n.sb-sidebar-title div > span {\n  display: block;\n  color: var(--sb-muted);\n  font-size: 11px;\n  margin-top: 2px;\n}\n.sb-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  min-height: 43px;\n  padding: 11px 17px;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid transparent;\n  transition:\n    background 0.15s,\n    box-shadow 0.15s;\n}\n.sb-button-primary {\n  background: var(--sb-blue);\n  color: white;\n  box-shadow: 0 3px 5px #165bfb12;\n}\n.sb-button-primary:hover:not(:disabled) {\n  background: #084ee9;\n  box-shadow: 0 4px 12px #165bfb25;\n}\n.sb-button-secondary {\n  border-color: #d8e0ee;\n  background: white;\n  color: #495870;\n}\n.sb-wide {\n  width: 100%;\n}\n.sb-new-button {\n  justify-content: flex-start;\n  margin-bottom: 20px;\n}\n.sb-search {\n  display: flex;\n  gap: 9px;\n  align-items: center;\n  color: #8f9aab;\n  border: 1px solid var(--sb-line);\n  border-radius: 8px;\n  padding: 9px 11px;\n}\n.sb-search input {\n  min-width: 0;\n  width: 100%;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 11px;\n  color: var(--sb-ink);\n}\n.sb-search:focus-within {\n  border-color: #a0bffd;\n}\n.sb-sidebar-section-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 27px 8px 12px;\n  color: #939dad;\n  font-size: 9px;\n  font-weight: 600;\n  letter-spacing: 1px;\n}\n.sb-sidebar-section-heading > span:last-child {\n  padding: 1px 5px;\n  background: #f0f3f7;\n  border-radius: 4px;\n  font-size: 9px;\n}\n.sb-session-list {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 80px;\n}\n.sb-session {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  border-radius: 9px;\n  text-align: left;\n  padding: 13px 9px;\n  margin-bottom: 5px;\n  background: transparent;\n  color: #68758b;\n  border: 1px solid transparent;\n}\n.sb-session:hover {\n  background: #f8faff;\n}\n.sb-session.is-active {\n  color: var(--sb-blue);\n  background: #eff4ff;\n  border-color: #e0eaff;\n}\n.sb-session-icon {\n  flex-shrink: 0;\n  align-self: flex-start;\n  margin-top: 2px;\n}\n.sb-session > span:nth-child(2) {\n  flex: 1;\n  min-width: 0;\n}\n.sb-session strong {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 600;\n}\n.sb-session small {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  color: #95a0b0;\n  font-size: 10px;\n  margin-top: 5px;\n}\n.sb-session small i {\n  width: 2px;\n  height: 2px;\n  border-radius: 100%;\n  background: currentColor;\n}\n.sb-sidebar-message {\n  color: var(--sb-muted);\n  font-size: 12px;\n  padding: 10px 8px;\n  line-height: 1.8;\n}\n.sb-sidebar-footer {\n  padding: 17px 13px 12px;\n  background: #f8f9fc;\n  border: 1px solid #edf0f6;\n  border-radius: 11px;\n  margin-top: 18px;\n}\n.sb-sidebar-footer > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  color: #53617a;\n}\n.sb-sidebar-footer p {\n  font-size: 10px;\n  color: #8a94a5;\n  line-height: 1.8;\n  margin: 9px 0 12px;\n}\n.sb-sidebar-footer a {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--sb-blue);\n  text-decoration: none;\n}\n.sb-main {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  overflow: auto;\n}\n.sb-new-site {\n  position: relative;\n  display: grid;\n  grid-template-columns: 1.3fr 1fr;\n  align-content: center;\n  gap: 26px 12px;\n  max-width: 1090px;\n  min-height: 100%;\n  margin: auto;\n  padding: 45px 64px 35px;\n}\n.sb-new-intro {\n  align-self: center;\n}\n.sb-kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 8px;\n  letter-spacing: 1.3px;\n  font-weight: 700;\n  color: #7b8eae;\n}\n.sb-kicker svg {\n  color: var(--sb-blue);\n}\n.sb-new-intro h1 {\n  font-size: clamp(32px, 3.4vw, 48px);\n  line-height: 1.16;\n  font-weight: 600;\n  letter-spacing: -2px;\n  margin: 18px 0 17px;\n}\n.sb-new-intro h1 > span {\n  color: var(--sb-blue);\n}\n.sb-new-intro > p {\n  color: #838da0;\n  font-size: 12px;\n  line-height: 1.9;\n}\n.sb-idea-art {\n  width: 290px;\n  height: 240px;\n  position: relative;\n  justify-self: end;\n  align-self: center;\n}\n.sb-art-orbit {\n  position: absolute;\n  border: 1px dashed #dfe5f2;\n  border-radius: 50%;\n  width: 245px;\n  height: 245px;\n  top: -5px;\n  left: 25px;\n  transform: rotate(-25deg);\n}\n.sb-art-orbit-two {\n  width: 285px;\n  height: 185px;\n  top: 30px;\n  left: 0;\n  transform: rotate(30deg);\n  border-color: #e9edf6;\n}\n.sb-art-browser {\n  position: absolute;\n  top: 47px;\n  left: 39px;\n  width: 239px;\n  height: 160px;\n  background: white;\n  border: 1px solid #dde4f0;\n  border-radius: 9px;\n  transform: rotate(-5deg);\n  box-shadow: 0 14px 36px #324e7c0c;\n  overflow: hidden;\n}\n.sb-art-browser-top {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 21px;\n  background: #f9fafc;\n  border-bottom: 1px solid #ecf0f7;\n  padding: 0 8px;\n}\n.sb-art-browser-top > i {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: #d9e2f0;\n}\n.sb-art-browser-top > span {\n  width: 89px;\n  height: 7px;\n  margin-left: 28px;\n  border-radius: 3px;\n  background: #eaf0f8;\n}\n.sb-art-browser-body {\n  padding: 12px 14px;\n}\n.sb-art-nav {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 14px;\n}\n.sb-art-nav b {\n  width: 28px;\n  height: 6px;\n  background: #7c9ad7;\n  border-radius: 2px;\n  margin-right: auto;\n}\n.sb-art-nav span {\n  width: 15px;\n  height: 3px;\n  background: #dce4f1;\n  border-radius: 2px;\n}\n.sb-art-hero {\n  display: flex;\n  gap: 16px;\n}\n.sb-art-hero > div:first-child {\n  flex: 1;\n  padding-top: 4px;\n}\n.sb-art-hero i {\n  display: block;\n  width: 87px;\n  height: 8px;\n  background: #b5c8e9;\n  border-radius: 2px;\n  margin-bottom: 5px;\n}\n.sb-art-hero i:nth-child(2) {\n  width: 65px;\n  background: #c7d7ef;\n}\n.sb-art-hero p {\n  height: 3px;\n  background: #e2e8f2;\n  margin-top: 5px;\n  width: 91px;\n}\n.sb-art-hero p:nth-of-type(2) {\n  width: 63px;\n}\n.sb-art-hero b {\n  display: block;\n  height: 12px;\n  width: 36px;\n  border-radius: 3px;\n  background: #165bfb;\n  margin-top: 9px;\n}\n.sb-art-image {\n  position: relative;\n  width: 82px;\n  height: 70px;\n  background: #e8edf9;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.sb-art-image span:first-child {\n  position: absolute;\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  background: #c2d0ee;\n  left: 34px;\n  top: -8px;\n}\n.sb-art-image span:last-child {\n  position: absolute;\n  width: 65px;\n  height: 75px;\n  border-radius: 38px 38px 0 0;\n  background: #96aedf;\n  top: 26px;\n  left: 10px;\n  transform: rotate(-25deg);\n}\n.sb-art-cards {\n  display: flex;\n  gap: 6px;\n  margin-top: 12px;\n}\n.sb-art-cards i {\n  flex: 1;\n  height: 16px;\n  background: #f0f4fa;\n  border-radius: 3px;\n}\n.sb-art-note {\n  position: absolute;\n  top: 13px;\n  left: 4px;\n  z-index: 1;\n  width: 94px;\n  padding: 12px;\n  background: #fff;\n  border: 1px solid #dfe7f6;\n  color: var(--sb-blue);\n  box-shadow: 0 5px 18px #1a3e7810;\n  border-radius: 9px;\n  transform: rotate(-9deg);\n}\n.sb-art-note > span {\n  position: absolute;\n  left: 36px;\n  top: 15px;\n  font-size: 9px;\n  font-weight: 600;\n  color: #5e7299;\n}\n.sb-art-note i {\n  display: block;\n  background: #e3eaf7;\n  height: 3px;\n  margin-top: 7px;\n  border-radius: 2px;\n}\n.sb-art-note i:last-child {\n  width: 70%;\n}\n.sb-art-spark {\n  position: absolute;\n  right: -1px;\n  top: 28px;\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  color: #e1a04c;\n  border-radius: 11px;\n  transform: rotate(12deg);\n  background: #fff6e5;\n  border: 1px solid #f6e7cc;\n}\n.sb-art-done {\n  position: absolute;\n  bottom: 18px;\n  left: 23px;\n  z-index: 1;\n  display: flex;\n  gap: 5px;\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e3eced;\n  border-radius: 7px;\n  padding: 9px 10px;\n  font-size: 8px;\n  color: #739084;\n  box-shadow: 0 4px 14px #1d5a3910;\n  transform: rotate(2deg);\n}\n.sb-idea-form {\n  grid-column: 1 / -1;\n  background: #fff;\n  border: 1px solid #dde5f1;\n  border-radius: 15px;\n  padding: 23px 24px 17px;\n  box-shadow: 0 8px 28px #304a7605;\n}\n.sb-idea-form:focus-within {\n  border-color: #9dbbfa;\n  box-shadow: 0 0 0 3px #165bfb05;\n}\n.sb-idea-form > label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n.sb-idea-form > textarea {\n  resize: vertical;\n  min-height: 100px;\n  max-height: 260px;\n  outline: none;\n  border: 0;\n  background: transparent;\n  width: 100%;\n  font-size: 12px;\n  line-height: 1.9;\n  color: var(--sb-ink);\n}\n.sb-idea-form > textarea::placeholder {\n  color: #a4adbc;\n}\n.sb-idea-options {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  border-top: 1px solid #f0f2f7;\n  padding-top: 14px;\n  margin-top: 8px;\n}\n.sb-session-name {\n  display: flex;\n  gap: 7px;\n  align-items: center;\n  color: #9ca6b6;\n  flex: 1;\n  min-width: 120px;\n}\n.sb-session-name input {\n  min-width: 0;\n  width: 100%;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 11px;\n  color: #647189;\n}\n.sb-required-label {\n  color: #647189;\n  font-size: 11px;\n  font-weight: 400;\n}\n.sb-idea-options select {\n  background: #f7f9fc;\n  color: #66748b;\n  border: 1px solid #e9edf4;\n  border-radius: 7px;\n  padding: 8px 7px;\n  font-size: 10px;\n}\n.sb-idea-options .sb-button {\n  font-size: 11px;\n  min-height: 38px;\n  padding: 9px 13px;\n}\n.sb-idea-starters {\n  grid-column: 1 / -1;\n  margin-top: 4px;\n}\n.sb-idea-starters > span {\n  display: block;\n  font-size: 8px;\n  font-weight: 600;\n  letter-spacing: 1.2px;\n  color: #9aa3b4;\n  margin-bottom: 13px;\n}\n.sb-idea-starters > div {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n.sb-idea-starters button {\n  position: relative;\n  text-align: left;\n  padding: 15px 13px;\n  border: 1px solid #e7ebf3;\n  border-radius: 10px;\n  background: #fff9;\n  transition:\n    background 0.2s,\n    border-color 0.2s;\n}\n.sb-idea-starters button:hover {\n  background: white;\n  border-color: #adc7ff;\n}\n.sb-starter-icon {\n  display: block;\n  color: #7992bc;\n  margin-bottom: 11px;\n}\n.sb-starter-1 {\n  color: #9a85b7;\n}\n.sb-starter-2 {\n  color: #b49b72;\n}\n.sb-idea-starters strong {\n  font-size: 11px;\n  font-weight: 600;\n}\n.sb-idea-starters p {\n  color: #919bad;\n  font-size: 9px;\n  line-height: 1.6;\n  margin-top: 5px;\n}\n.sb-idea-starters button > svg {\n  position: absolute;\n  right: 12px;\n  top: 17px;\n  color: #a3afc2;\n}\n.sb-new-footnote {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 19px;\n  grid-column: 1 / -1;\n  margin-top: 10px;\n  color: #a4adbc;\n  font-size: 8px;\n}\n.sb-new-footnote b {\n  color: #8c97aa;\n  font-weight: 400;\n  margin-left: 4px;\n}\n.sb-new-footnote i {\n  width: 27px;\n  height: 1px;\n  background: #e1e6ef;\n}\n.sb-workspace {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n.sb-workspace-header {\n  padding: 25px 30px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n  background: white;\n}\n.sb-eyebrow {\n  display: block;\n  color: #9aa4b4;\n  font-size: 8px;\n  letter-spacing: 1.2px;\n  font-weight: 600;\n}\n.sb-workspace-header h1 {\n  font-size: 21px;\n  font-weight: 600;\n  letter-spacing: -0.6px;\n  margin-top: 6px;\n  overflow-wrap: anywhere;\n}\n.sb-workspace-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n.sb-status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 9px;\n  border: 1px solid #e2eaf8;\n  border-radius: 6px;\n  color: #6884b1;\n  background: #f7faff;\n  font-size: 9px;\n  white-space: nowrap;\n}\n.sb-status-pill i {\n  width: 5px;\n  height: 5px;\n  background: #8faee6;\n  border-radius: 100%;\n}\n.sb-icon-button {\n  display: grid;\n  place-items: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid #e7ecf4;\n  background: white;\n  color: #8896ad;\n  border-radius: 7px;\n}\n.sb-steps {\n  display: flex;\n  flex-shrink: 0;\n  list-style: none;\n  gap: 10px;\n  padding: 0 30px 20px;\n  background: white;\n  border-bottom: 1px solid var(--sb-line);\n  margin: 0;\n}\n.sb-steps li {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #a6afbd;\n  font-size: 9px;\n  white-space: nowrap;\n  flex: 1;\n}\n.sb-steps li:not(:last-child)::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: #e9edf4;\n  margin-left: 3px;\n}\n.sb-steps li > span {\n  display: grid;\n  place-items: center;\n  width: 19px;\n  height: 19px;\n  border-radius: 50%;\n  font-size: 8px;\n  background: #f1f4f9;\n  border: 1px solid #e9edf3;\n}\n.sb-steps li.is-current {\n  color: var(--sb-blue);\n  font-weight: 600;\n}\n.sb-steps li.is-current > span {\n  color: white;\n  background: var(--sb-blue);\n  border-color: var(--sb-blue);\n}\n.sb-steps li.is-done {\n  color: #7089af;\n}\n.sb-steps li.is-done > span {\n  color: #6f97c2;\n  background: #eff6ff;\n  border-color: #e0ebfc;\n}\n.sb-workspace-columns {\n  display: grid;\n  grid-template-columns: minmax(300px, 1fr) 340px;\n  flex: 1;\n  min-height: 0;\n}\n.sb-conversation {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n  background: #fcfdff;\n}\n.sb-conversation-top {\n  display: flex;\n  gap: 9px;\n  align-items: center;\n  padding: 19px 26px;\n  border-bottom: 1px solid #eef1f6;\n}\n.sb-evo-avatar {\n  display: grid;\n  place-items: center;\n  width: 33px;\n  height: 33px;\n  flex-shrink: 0;\n  border: 1px solid #e0e9ff;\n  border-radius: 11px;\n  color: var(--sb-blue);\n  background: linear-gradient(135deg, #f0f5ff, #f7f5ff);\n}\n.sb-conversation-top strong {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n}\n.sb-conversation-top div > span {\n  display: block;\n  color: #94a0b2;\n  font-size: 9px;\n  margin-top: 3px;\n}\n.sb-text-only {\n  color: #a7b0bf;\n  font-size: 9px;\n  margin-left: auto;\n}\n.sb-messages {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 19px 30px;\n  scroll-behavior: smooth;\n}\n.sb-conversation-start {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  color: #aab3c3;\n  font-size: 7px;\n  letter-spacing: 1.5px;\n  margin-bottom: 28px;\n}\n.sb-conversation-start::before,\n.sb-conversation-start::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: #edf0f5;\n}\n.sb-welcome-message {\n  display: flex;\n  gap: 12px;\n  max-width: 460px;\n  margin-bottom: 22px;\n}\n.sb-welcome-message h2 {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.4px;\n  margin: 6px 0 10px;\n}\n.sb-welcome-message p {\n  color: #8692a5;\n  font-size: 12px;\n  line-height: 1.9;\n}\n.sb-message {\n  max-width: 94%;\n  margin-bottom: 24px;\n}\n.sb-message-user {\n  margin-left: 28px;\n}\n.sb-message-author {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 9px;\n  color: #91a0b6;\n  margin-bottom: 8px;\n}\n.sb-message-author strong {\n  font-weight: 600;\n  color: #64738a;\n}\n.sb-message-author time {\n  font-size: 8px;\n  margin-left: 3px;\n  color: #a8b2c2;\n}\n.sb-message-author > svg {\n  color: var(--sb-blue);\n}\n.sb-message-content {\n  overflow-wrap: anywhere;\n  font-size: 12px;\n  line-height: 1.95;\n  color: #58667d;\n}\n.sb-message-content a {\n  color: var(--sb-blue);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n.sb-message-user .sb-message-content {\n  white-space: pre-wrap;\n  padding: 13px 17px;\n  background: #edf3ff;\n  border: 1px solid #e4ecfc;\n  border-radius: 12px 3px 12px 12px;\n  color: #496088;\n}\n.sb-message-pending {\n  opacity: 0.7;\n}\n/* The question Evo asks, in a panel above the message box: borderless option rows, the choice shown by a light\n   blue fill. Single cards and question groups share it. */\n.sb-question-panel {\n  position: relative;\n  margin-bottom: 8px;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 4px 16px rgba(33, 39, 54, 0.06);\n  color: #212736;\n  font-size: 16px;\n  line-height: 24px;\n}\n.sb-question-panel *,\n.sb-question-panel *::before,\n.sb-question-panel *::after {\n  box-sizing: border-box;\n}\n.sb-question-panel__toggle {\n  position: absolute;\n  top: 14px;\n  right: 8px;\n  z-index: 1;\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #464c5c;\n  cursor: pointer;\n}\n.sb-question-panel__toggle:hover {\n  background: #edf0f5;\n}\n.sb-question-panel__toggle svg {\n  transition: transform 160ms ease;\n}\n.sb-question-panel.is-collapsed .sb-question-panel__toggle {\n  top: 12px;\n}\n.sb-question-panel.is-collapsed .sb-question-panel__toggle svg {\n  transform: rotate(180deg);\n}\n.sb-question-panel__collapsed {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 56px;\n  padding: 8px 48px 8px 16px;\n}\n.sb-question-panel__collapsed p {\n  flex: 1 1 auto;\n  min-width: 0;\n  margin: 0;\n  overflow: hidden;\n  color: #212736;\n  font-size: 14px;\n  line-height: 20px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.sb-question-panel__collapsed strong {\n  font-weight: 600;\n}\n.sb-question-panel__muted {\n  color: #646e82;\n}\n.sb-question-panel__collapsed .sb-question-button {\n  height: 36px;\n}\n.sb-choice-card__header {\n  padding: 14px 48px 0 16px;\n}\n.sb-choice-card__question {\n  margin: 0;\n  color: #212736;\n  font-size: 17px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.sb-choice-card__hint {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  color: #646e82;\n  font-size: 13px;\n  line-height: 18px;\n}\n.sb-choice-card__chip {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 4px;\n  background: #edf0f5;\n  color: #464c5c;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n}\n.sb-choice-card__body {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 12px 16px 16px;\n}\n.sb-choice-card__options {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.sb-choice-card__options--palette {\n  display: grid;\n  grid-template-columns: repeat(var(--sb-choice-columns, 3), minmax(0, 1fr));\n  gap: 12px;\n}\n.sb-choice-card__options--visual {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n.sb-choice-card__options--fonts {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n.sb-choice-card__option {\n  position: relative;\n  display: flex;\n  border-radius: 10px;\n  background: #f7f8fa;\n  transition: background 150ms ease;\n}\n.sb-choice-card__option:hover {\n  background: #eff1f4;\n}\n.sb-choice-card__option.is-selected {\n  background: #eff4ff;\n}\n.sb-choice-card__option.is-selected:hover {\n  background: #e4ecff;\n}\n.sb-choice-card__option:has(input:focus-visible) {\n  outline: 3px solid #9ebbff;\n  outline-offset: 2px;\n}\n.sb-choice-card__option:has(input:disabled) {\n  opacity: 0.6;\n}\n.sb-choice-card__options--palette .sb-choice-card__option,\n.sb-choice-card__options--visual .sb-choice-card__option,\n.sb-choice-card__options--fonts .sb-choice-card__option {\n  border-radius: 12px;\n}\n.sb-choice-card__label {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n  cursor: pointer;\n}\n.sb-choice-card__option:has(input:disabled) .sb-choice-card__label {\n  cursor: default;\n}\n.sb-choice-card__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 9px 12px;\n}\n.sb-choice-card__row > input {\n  margin-top: 1px;\n}\n/* An option without a description centres its control on the title. */\n.sb-choice-card__row:not(:has(.sb-choice-card__description)) {\n  align-items: center;\n}\n.sb-choice-card__row:not(:has(.sb-choice-card__description)) > input {\n  margin-top: 0;\n}\n.sb-choice-card__row:not(:has(.sb-choice-card__description)) .sb-choice-card__title {\n  font-weight: 500;\n}\n.sb-choice-card__options--list .has-flag .sb-choice-card__row {\n  padding-right: 46px;\n}\n.sb-choice-card__options--palette .sb-choice-card__row {\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n}\n.sb-choice-card__options--palette .sb-choice-card__row > input {\n  margin-top: 0;\n}\n.sb-choice-card__options--visual .sb-choice-card__row {\n  padding: 10px 12px 12px;\n}\n.sb-choice-card__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n.sb-choice-card__title {\n  color: #111e39;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 20px;\n}\n.sb-choice-card__description {\n  color: #858585;\n  font-size: 13px;\n  line-height: 18px;\n}\n.sb-choice-card__swatches {\n  display: flex;\n  flex: 0 0 96px;\n  height: 40px;\n  overflow: hidden;\n  border: 1px solid #d5dae3;\n  border-radius: 8px;\n}\n.sb-choice-card__options--palette .sb-choice-card__swatches {\n  flex: 1 1 auto;\n  height: 48px;\n}\n.sb-choice-card__swatch {\n  flex: 1 1 0;\n}\n.sb-choice-card__swatch + .sb-choice-card__swatch {\n  box-shadow: inset 1px 0 0 rgba(33, 39, 54, 0.12);\n}\n.sb-choice-card__visual {\n  display: block;\n  height: 88px;\n  margin: 8px 8px 0;\n  overflow: hidden;\n  border-radius: 8px;\n  background: #f3f6ff;\n}\n.sb-choice-card__visual--fonts {\n  height: auto;\n  background: transparent;\n}\n.sb-design-preview {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n/* Controls: a ring with a dot, a rounded square with a round-capped tick. */\n.sb-question-panel input[type='radio'],\n.sb-question-panel input[type='checkbox'] {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  border: 1.5px solid #8c94a6;\n  background: #fff;\n  cursor: pointer;\n  appearance: none;\n  -webkit-appearance: none;\n}\n.sb-question-panel input[type='radio'] {\n  border-radius: 50%;\n}\n.sb-question-panel input[type='checkbox'] {\n  border-radius: 6px;\n}\n.sb-question-panel input[type='radio']:checked {\n  border-color: #165bfb;\n  background: #165bfb;\n  box-shadow: inset 0 0 0 3.5px #fff;\n}\n.sb-question-panel input[type='checkbox']:checked {\n  border-color: #165bfb;\n  background: #165bfb\n    url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M6 12.5l4 4L18 8' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")\n    center / 14px 14px no-repeat;\n}\n.sb-question-panel input[type='radio']:focus-visible,\n.sb-question-panel input[type='checkbox']:focus-visible {\n  outline: none;\n}\n.sb-question-panel input:disabled {\n  cursor: default;\n}\n.sb-choice-card__option--own {\n  align-items: center;\n  gap: 10px;\n  padding: 2px 12px;\n}\n.sb-choice-card__own-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 36px;\n  padding: 0;\n  border: 0;\n  outline: none;\n  background: transparent;\n  color: #212736;\n  font: inherit;\n  font-size: 15px;\n  line-height: 20px;\n}\n.sb-choice-card__own-input::placeholder {\n  color: #646e82;\n}\n/* The tradeoff note of an option: a yellow badge with a dark tip. */\n.sb-choice-card__flag {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border: 1px solid #f5c451;\n  border-radius: 13px;\n  background: #ffe7b0;\n  color: #7a4d00;\n  box-shadow:\n    0 0 0 2px #fff,\n    0 2px 6px rgba(33, 39, 54, 0.18);\n  cursor: pointer;\n}\n.sb-choice-card__flag:hover {\n  background: #ffda8a;\n}\n.sb-choice-card__flag:focus-visible {\n  outline: 3px solid #9ebbff;\n  outline-offset: 1px;\n}\n.sb-choice-card__options--list .sb-choice-card__flag {\n  top: 9px;\n  right: 10px;\n}\n.sb-choice-card__tip {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: -10px;\n  z-index: 30;\n  display: none;\n  width: 280px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #212736;\n  box-shadow: 0 8px 24px rgba(33, 39, 54, 0.24);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n  white-space: normal;\n  cursor: default;\n}\n.sb-choice-card__tip::after {\n  content: '';\n  position: absolute;\n  right: 18px;\n  bottom: 100%;\n  border: 6px solid transparent;\n  border-bottom-color: #212736;\n}\n.sb-choice-card__flag:hover .sb-choice-card__tip,\n.sb-choice-card__flag:focus-visible .sb-choice-card__tip,\n.sb-choice-card__flag.is-open .sb-choice-card__tip {\n  display: block;\n}\n.sb-choice-card__footer,\n.sb-survey__footer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px 12px 16px;\n}\n.sb-choice-card__footer {\n  justify-content: flex-end;\n}\n.sb-question-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  border: 0;\n  border-radius: 8px;\n  font: inherit;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 20px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition:\n    background 150ms ease,\n    color 150ms ease;\n}\n.sb-question-button:focus-visible {\n  outline: 3px solid #9ebbff;\n  outline-offset: 2px;\n}\n.sb-question-button--primary {\n  background: #165bfb;\n  color: #fff;\n}\n.sb-question-button--primary:hover:not(:disabled) {\n  background: #1348c2;\n}\n.sb-question-button--primary:disabled {\n  background: #edf0f5;\n  color: #9199ab;\n  cursor: not-allowed;\n}\n.sb-question-button--ghost {\n  background: transparent;\n  color: #464c5c;\n}\n.sb-question-button--ghost:hover:not(:disabled) {\n  background: #edf0f5;\n  color: #212736;\n}\n.sb-question-button--ghost:disabled {\n  color: #b4bccb;\n  cursor: not-allowed;\n}\n.sb-survey__question:focus {\n  outline: none;\n}\n.sb-survey__text {\n  display: block;\n  width: 100%;\n  min-height: 84px;\n  padding: 10px 12px;\n  resize: vertical;\n  border: 0;\n  border-radius: 10px;\n  outline: none;\n  background: #f7f8fa;\n  color: #212736;\n  font: inherit;\n  font-size: 15px;\n  line-height: 20px;\n}\n.sb-survey__text::placeholder {\n  color: #646e82;\n}\n.sb-survey__text:focus-visible {\n  outline: 3px solid #9ebbff;\n  outline-offset: 2px;\n}\n.sb-survey__nav {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n.sb-survey__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n.sb-survey__arrow {\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #646e82;\n  cursor: pointer;\n}\n.sb-survey__arrow:hover:not(:disabled) {\n  background: #edf0f5;\n  color: #212736;\n}\n.sb-survey__arrow:disabled {\n  color: #c8ceda;\n  cursor: not-allowed;\n}\n.sb-survey__counter {\n  height: 36px;\n  padding: 0 8px 0 10px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #464c5c;\n  font: inherit;\n  font-size: 14px;\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n  line-height: 20px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.sb-survey__counter:hover:not(:disabled),\n.sb-survey__counter[aria-expanded='true'] {\n  background: #edf0f5;\n  color: #212736;\n}\n.sb-survey__arrow:focus-visible,\n.sb-survey__counter:focus-visible,\n.sb-survey__list-item:focus-visible,\n.sb-question-panel__toggle:focus-visible {\n  outline: 3px solid #9ebbff;\n  outline-offset: 2px;\n}\n.sb-survey__list {\n  position: absolute;\n  bottom: calc(100% + 14px);\n  left: -8px;\n  z-index: 30;\n  width: 440px;\n  max-width: calc(100vw - 32px);\n  max-height: 480px;\n  overflow: auto;\n  padding: 8px;\n  border: 1px solid #dfe2e8;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 12px 32px rgba(33, 39, 54, 0.16);\n}\n.sb-survey__list-head {\n  display: flex;\n  justify-content: space-between;\n  padding: 6px 8px 8px;\n  color: #646e82;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n}\n.sb-survey__list ol {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.sb-survey__list-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  width: 100%;\n  padding: 8px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #212736;\n  font: inherit;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: left;\n  cursor: pointer;\n}\n.sb-survey__list-item:hover {\n  background: #f7f8fa;\n}\n.sb-survey__list-item.is-current {\n  background: #eff4ff;\n}\n.sb-survey__list-number {\n  display: flex;\n  flex: 0 0 22px;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  margin-top: -1px;\n  border-radius: 11px;\n  background: #edf0f5;\n  color: #464c5c;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n}\n.sb-survey__list-item.is-done .sb-survey__list-number {\n  background: #dee8ff;\n  color: #1348c2;\n}\n.sb-survey__list-item.is-current .sb-survey__list-number {\n  background: #165bfb;\n  color: #fff;\n}\n.sb-survey__list-copy {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.sb-survey__list-question {\n  font-weight: 600;\n}\n.sb-survey__list-status {\n  overflow: hidden;\n  color: #646e82;\n  font-size: 13px;\n  line-height: 18px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.sb-survey__list-item.is-done .sb-survey__list-status {\n  color: #464c5c;\n}\n@media (max-width: 600px) {\n  .sb-question-panel__toggle {\n    top: 12px;\n    right: 4px;\n  }\n  .sb-choice-card__header {\n    padding: 12px 40px 0 12px;\n  }\n  .sb-choice-card__question {\n    font-size: 16px;\n    line-height: 22px;\n  }\n  .sb-choice-card__body {\n    padding: 10px 12px 12px;\n  }\n  .sb-choice-card__options--visual {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 8px;\n  }\n  .sb-choice-card__options--visual .sb-choice-card__label {\n    flex-direction: row;\n    align-items: stretch;\n  }\n  .sb-choice-card__options--visual .sb-choice-card__visual {\n    flex: 0 0 96px;\n    width: 96px;\n    height: auto;\n    min-height: 72px;\n    margin: 8px 0 8px 8px;\n  }\n  .sb-choice-card__options--visual .sb-choice-card__flag {\n    top: 12px;\n    right: auto;\n    left: 70px;\n  }\n  .sb-choice-card__options--visual .sb-choice-card__tip {\n    right: auto;\n    left: -10px;\n    width: 250px;\n  }\n  .sb-choice-card__options--visual .sb-choice-card__tip::after {\n    right: auto;\n    left: 18px;\n  }\n  .sb-choice-card__options--palette {\n    gap: 8px;\n  }\n  .sb-choice-card__options--palette .sb-choice-card__row {\n    gap: 6px;\n    padding: 10px 8px;\n  }\n  .sb-choice-card__options--palette .sb-choice-card__swatches {\n    height: 40px;\n  }\n  .sb-choice-card__options--fonts {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .sb-choice-card__footer,\n  .sb-survey__footer {\n    flex-wrap: wrap;\n    padding: 0 12px 12px;\n  }\n  .sb-choice-card__footer,\n  .sb-survey__actions {\n    display: grid;\n    grid-auto-columns: minmax(0, 1fr);\n    grid-auto-flow: column;\n    width: 100%;\n    margin-left: 0;\n  }\n  .sb-survey__nav {\n    justify-content: center;\n    width: 100%;\n  }\n  .sb-survey__arrow {\n    width: 44px;\n    height: 44px;\n  }\n  .sb-survey__counter {\n    height: 44px;\n  }\n  .sb-survey__list {\n    left: 0;\n  }\n  .sb-question-button {\n    width: 100%;\n    height: 44px;\n  }\n  .sb-question-panel__collapsed .sb-question-button {\n    width: auto;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .sb-choice-card__option,\n  .sb-question-button,\n  .sb-question-panel__toggle svg {\n    transition: none;\n  }\n}\n/* The temporarily hidden typography cards and constructors keep their own pieces. */\n.sb-font-specimen {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 10px;\n  border: 1px solid #e3e9f6;\n  border-radius: 10px;\n  background: #fff;\n}\n.sb-font-specimen__aa {\n  flex: 0 0 auto;\n  color: #263654;\n  font-size: 30px;\n  line-height: 1;\n}\n.sb-font-specimen__copy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n.sb-font-specimen__heading {\n  color: #1f2e49;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.25;\n}\n.sb-font-specimen__body {\n  color: #596983;\n  font-size: 12px;\n  line-height: 1.45;\n}\n.sb-palette-ctor,\n.sb-font-ctor {\n  display: grid;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #cbdcff;\n  border-radius: 13px;\n  background: rgba(255, 255, 255, 0.82);\n}\n.sb-palette-ctor__strip {\n  display: flex;\n  height: 38px;\n  overflow: hidden;\n  border: 1px solid #dbe4f7;\n  border-radius: 10px;\n}\n.sb-palette-ctor__strip i {\n  flex: 1;\n}\n.sb-palette-ctor fieldset {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n.sb-palette-ctor legend {\n  margin-bottom: 6px;\n  padding: 0;\n  color: #44546e;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n.sb-palette-ctor__row,\n.sb-font-ctor__row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n.sb-palette-ctor__row:has(> :only-child) {\n  grid-template-columns: minmax(0, 1fr);\n}\n.sb-palette-ctor__field label,\n.sb-font-ctor__field label {\n  display: block;\n  margin-bottom: 4px;\n  color: #596983;\n  font-size: 12px;\n  font-weight: 600;\n}\n.sb-palette-ctor__input {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px;\n  border: 1px solid #d9e3f5;\n  border-radius: 9px;\n  background: #fff;\n}\n.sb-palette-ctor__input input[type='color'] {\n  flex: 0 0 34px;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: none;\n  cursor: pointer;\n}\n.sb-palette-ctor__input input[type='text'] {\n  min-width: 0;\n  flex: 1;\n  border: 0;\n  outline: none;\n  background: transparent;\n  color: #27344a;\n  font: inherit;\n  font-size: 13px;\n  text-transform: uppercase;\n}\n.sb-palette-ctor__input:focus-within,\n.sb-font-ctor__field select:focus {\n  border-color: #668eff;\n  box-shadow: 0 0 0 3px rgba(75, 124, 255, 0.11);\n}\n.sb-palette-ctor__hint,\n.sb-font-ctor__note {\n  margin: 0;\n  color: #8a5a2b;\n  font-size: 12px;\n  line-height: 1.45;\n}\n.sb-font-ctor__field select {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #d9e3f5;\n  border-radius: 9px;\n  outline: none;\n  background: #fff;\n  color: #27344a;\n  font: inherit;\n  font-size: 13px;\n}\n@media (max-width: 560px) {\n  .sb-palette-ctor__row,\n  .sb-font-ctor__row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n/* The wow played when the boldest creativity level is chosen (see utils/creativeBoom.ts). */\n.sb-boom-canvas {\n  position: fixed;\n  inset: 0;\n  z-index: 2147483000;\n  width: 100vw;\n  height: 100vh;\n  pointer-events: none;\n}\n.sb-boom-wow {\n  position: fixed;\n  top: 150px;\n  left: 50%;\n  z-index: 2147483001;\n  display: grid;\n  width: 180px;\n  height: 150px;\n  margin-left: -90px;\n  place-items: center;\n  pointer-events: none;\n  animation:\n    sb-boom-wow-in 600ms cubic-bezier(0.2, 1.7, 0.4, 1) both,\n    sb-boom-wow-out 400ms ease 2s forwards;\n}\n.sb-boom-wow::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: #ffd23f;\n  clip-path: polygon(\n    50% 0,\n    60% 22%,\n    84% 8%,\n    76% 34%,\n    100% 40%,\n    80% 58%,\n    96% 82%,\n    70% 76%,\n    62% 100%,\n    50% 80%,\n    38% 100%,\n    30% 76%,\n    4% 82%,\n    20% 58%,\n    0 40%,\n    24% 34%,\n    16% 8%,\n    40% 22%\n  );\n  animation: sb-boom-spin 6s linear infinite;\n}\n.sb-boom-wow b {\n  position: relative;\n  color: #7a2cff;\n  font:\n    900 34px Inter,\n    system-ui,\n    sans-serif;\n  letter-spacing: 0.04em;\n  text-shadow: 2px 2px 0 #fff;\n  transform: rotate(-8deg);\n}\n.sb-boom-rocket {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2147483001;\n  font-size: 46px;\n  line-height: 1;\n  pointer-events: none;\n  filter: drop-shadow(0 8px 10px rgba(60, 30, 120, 0.35));\n  will-change: transform;\n}\n@keyframes sb-boom-wow-in {\n  from {\n    transform: scale(0) rotate(-30deg);\n  }\n  to {\n    transform: scale(1) rotate(0);\n  }\n}\n@keyframes sb-boom-wow-out {\n  to {\n    opacity: 0;\n    transform: translateY(-22px) scale(0.92);\n  }\n}\n@keyframes sb-boom-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .sb-boom-canvas,\n  .sb-boom-wow,\n  .sb-boom-rocket {\n    display: none;\n  }\n}\n.sb-working {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 13px 0;\n  color: #7d8ba4;\n}\n.sb-working strong {\n  font-size: 10px;\n  font-weight: 500;\n}\n.sb-working p {\n  font-size: 9px;\n  color: #9ba6b9;\n  margin-top: 4px;\n}\n.sb-thinking {\n  display: flex;\n  gap: 3px;\n  margin-left: auto;\n}\n.sb-thinking i {\n  width: 4px;\n  height: 4px;\n  border-radius: 100%;\n  background: #96b0e0;\n  animation: sb-think 1.4s infinite;\n}\n.sb-thinking i:nth-child(2) {\n  animation-delay: 0.2s;\n}\n.sb-thinking i:nth-child(3) {\n  animation-delay: 0.4s;\n}\n.sb-composer-area {\n  padding: 15px 26px 17px;\n  background: #fcfdff;\n}\n.sb-composer {\n  border: 1px solid #dce4f3;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 14px #384c7404;\n  padding: 13px 14px 9px;\n}\n.sb-composer:focus-within {\n  border-color: #98b8fa;\n  box-shadow: 0 0 0 3px #165bfb05;\n}\n/* Continue chat from the sidebar draws the eye back to the message box. */\n.sb-composer.is-called {\n  border-color: #165bfb;\n  animation: sb-composer-call 1.4s ease-out;\n}\n@keyframes sb-composer-call {\n  0% { box-shadow: 0 0 0 0 #165bfb55; }\n  70% { box-shadow: 0 0 0 10px #165bfb00; }\n  100% { box-shadow: 0 0 0 0 #165bfb00; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .sb-composer.is-called { animation: none; }\n}\n.sb-composer.is-disabled {\n  background: #f9fafd;\n}\n.sb-composer textarea {\n  border: none;\n  outline: none;\n  resize: vertical;\n  min-height: 50px;\n  max-height: 160px;\n  width: 100%;\n  font-size: 12px;\n  line-height: 1.8;\n  background: transparent;\n  color: var(--sb-ink);\n}\n.sb-composer textarea::placeholder {\n  color: #a0abbd;\n}\n.sb-composer-bottom {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n.sb-composer-bottom > span {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: #a0aabc;\n  font-size: 8px;\n}\n.sb-composer-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-left: auto;\n}\n.sb-composer-actions .sb-button {\n  min-height: 34px;\n  padding: 8px 12px;\n  gap: 6px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  white-space: nowrap;\n  transition:\n    background 0.15s,\n    border-color 0.15s,\n    color 0.15s,\n    box-shadow 0.15s;\n}\n.sb-composer-actions .sb-button > svg,\n.sb-composer-actions .sb-spinner {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n.sb-composer-actions .sb-button-secondary {\n  background: #f5f7fb;\n  border-color: #e8ecf4;\n  color: #5d6b82;\n}\n.sb-composer-actions .sb-button-secondary:hover:not(:disabled) {\n  background: #edf3ff;\n  border-color: #d6e3fd;\n  color: var(--sb-blue);\n}\n.sb-composer-actions .sb-button-primary {\n  box-shadow: 0 1px 2px #165bfb14;\n}\n.sb-composer-actions .sb-button-primary:hover:not(:disabled) {\n  box-shadow: 0 2px 6px #165bfb25;\n}\n.sb-composer-actions .sb-button:disabled {\n  opacity: 1;\n  background: #f1f4f9;\n  border-color: #e8ecf2;\n  color: #9aa6b9;\n  box-shadow: none;\n}\n.sb-composer-hint {\n  display: flex;\n  justify-content: space-between;\n  gap: 6px;\n  color: #a8b1c0;\n  font-size: 8px;\n  padding: 10px 2px 0;\n}\n.sb-chat-stage-note {\n  display: flex;\n  gap: 9px;\n  align-items: flex-start;\n  color: #8897ae;\n  padding: 0 0 12px;\n  font-size: 10px;\n  line-height: 1.7;\n}\n.sb-chat-stage-note svg {\n  flex-shrink: 0;\n}\n.sb-details {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  border-left: 1px solid var(--sb-line);\n  background: white;\n  padding: 23px 21px 0;\n}\n/* Until Evo finishes the interview the chat takes the whole width. */\n.sb-workspace-columns.sb-without-details {\n  grid-template-columns: minmax(300px, 1fr);\n}\n.sb-details-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 14px 0 18px;\n  border-top: 1px solid var(--sb-line);\n}\n.sb-details-actions .sb-button {\n  flex: 1 1 140px;\n  justify-content: center;\n}\n.sb-details-heading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 21px;\n}\n.sb-icon-tile {\n  display: grid;\n  place-items: center;\n  color: #7690b7;\n  width: 34px;\n  height: 35px;\n  border-radius: 9px;\n  background: #f3f6fb;\n}\n.sb-details-heading h2 {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: -0.2px;\n}\n.sb-details-heading p {\n  font-size: 9px;\n  margin-top: 5px;\n  color: #9aa5b7;\n}\n.sb-stage-card {\n  padding: 17px;\n  border: 1px solid #e2eafb;\n  background: linear-gradient(135deg, #f6f9ff, #f9faff);\n  border-radius: 12px;\n  margin-bottom: 21px;\n}\n.sb-stage-card .sb-eyebrow {\n  display: flex;\n  justify-content: space-between;\n  color: #8ca0c4;\n  font-size: 7px;\n}\n.sb-stage-card .sb-eyebrow > span {\n  letter-spacing: 0.4px;\n}\n.sb-stage-card h3 {\n  font-size: 17px;\n  font-weight: 600;\n  letter-spacing: -0.4px;\n  margin: 11px 0 9px;\n}\n.sb-stage-card p {\n  color: #8b9ab2;\n  font-size: 10px;\n  line-height: 1.8;\n  margin-bottom: 15px;\n}\n.sb-stage-card .sb-button {\n  min-height: 36px;\n  padding: 9px 11px;\n  font-size: 10px;\n}\n.sb-stage-card .sb-button > svg:last-child {\n  margin-left: auto;\n}\n.sb-text-button {\n  background: none;\n  border: none;\n  color: var(--sb-blue);\n  font-size: 10px;\n  font-weight: 500;\n  padding: 10px 0;\n  text-decoration: none;\n}\n.sb-panel-tabs {\n  display: flex;\n  gap: 21px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  border-bottom: 1px solid var(--sb-line);\n  flex-shrink: 0;\n}\n.sb-panel-tabs > button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2px 0 12px;\n  border: none;\n  background: none;\n  color: #9aa6b8;\n  font-size: 10px;\n  white-space: nowrap;\n}\n.sb-panel-tabs > button.is-active {\n  color: var(--sb-blue);\n  font-weight: 600;\n}\n.sb-panel-tabs > button.is-active::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: var(--sb-blue);\n  border-radius: 3px;\n}\n.sb-panel-tabs > button > span {\n  font-size: 8px;\n  background: #edf3ff;\n  color: #7897cc;\n  border-radius: 4px;\n  padding: 1px 4px;\n}\n.sb-panel-body {\n  min-height: 0;\n  flex: 1;\n  overflow-y: auto;\n  padding: 19px 1px 22px;\n  overscroll-behavior: contain;\n}\n.sb-panel-caption {\n  display: flex;\n  justify-content: space-between;\n  gap: 7px;\n  align-items: center;\n  margin-bottom: 14px;\n  font-size: 7px;\n  color: #9ba8bc;\n  letter-spacing: 0.9px;\n}\n.sb-panel-caption > span:last-child:not(.sb-saved-dot) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 55%;\n  letter-spacing: 0;\n}\n.sb-saved-dot {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  letter-spacing: 0;\n  font-size: 8px;\n  color: #83a594;\n}\n.sb-saved-dot::before {\n  content: '';\n  width: 4px;\n  height: 4px;\n  border-radius: 100%;\n  background: #8cb8a2;\n}\n.sb-panel-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  color: #a7b6cd;\n  padding: 34px 12px;\n  border: 1px dashed #e2e8f2;\n  border-radius: 11px;\n  background: #fbfcff;\n}\n.sb-panel-empty h3 {\n  font-size: 12px;\n  color: #7e91ad;\n  margin-top: 14px;\n  font-weight: 500;\n}\n.sb-panel-empty p {\n  font-size: 10px;\n  color: #a0aec1;\n  line-height: 1.9;\n  margin-top: 9px;\n  max-width: 230px;\n}\n.sb-brief-requirements .sb-requirement-text {\n  margin: 0;\n}\n.sb-requirement details {\n  margin-top: 4px;\n}\n.sb-requirement summary {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  color: #95a4ba;\n  font-size: 10px;\n  list-style: none;\n}\n.sb-requirement summary > svg {\n  flex-shrink: 0;\n  color: #a9b7cb;\n  transition: transform 0.15s;\n}\n.sb-requirement details[open] summary > svg {\n  transform: rotate(90deg);\n}\n.sb-assumption {\n  display: inline-block;\n  margin-left: 6px;\n  font-size: 9px;\n  background: #faf6ed;\n  color: #ae976f;\n  padding: 3px 5px;\n  border-radius: 4px;\n}\n.sb-requirement-value {\n  white-space: pre-line;\n}\n.sb-brief-summary {\n  color: #4e6384;\n  font-size: 13px;\n  line-height: 1.65;\n  overflow-wrap: anywhere;\n}\n.sb-brief-summary p {\n  margin: 0 0 14px;\n  white-space: pre-line;\n}\n.sb-brief-summary h3 {\n  margin: 20px 0 8px;\n  color: #253653;\n  font-size: 14px;\n  font-weight: 650;\n  line-height: 1.4;\n}\n.sb-brief-summary > :first-child {\n  margin-top: 0;\n}\n.sb-brief-summary ul {\n  display: grid;\n  gap: 8px;\n  margin: 0;\n  padding-left: 18px;\n  list-style: disc;\n}\n.sb-brief-summary li {\n  padding-left: 2px;\n}\n.sb-brief-summary li::marker {\n  color: #a0aec2;\n}\n.sb-brief-summary strong {\n  color: #344663;\n  font-weight: 600;\n}\n.sb-value-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n.sb-value-list > div {\n  padding: 2px 6px;\n  background: #f2f5fa;\n  border-radius: 4px;\n}\n.sb-value-fields > div {\n  margin-bottom: 6px;\n}\n.sb-value-fields dt {\n  color: #9ba7b9;\n  font-size: 8px;\n}\n.sb-value-fields dd {\n  margin: 0;\n}\n.sb-requirement-context {\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px solid #edf1f6;\n  color: #9aa9be;\n  font-size: 9px;\n  line-height: 1.7;\n}\n.sb-requirement-context p {\n  margin-bottom: 7px;\n}\n.sb-requirement-context blockquote {\n  font-style: italic;\n  padding-left: 7px;\n  border-left: 2px solid #dce8fc;\n  margin: 8px 0;\n}\n.sb-requirement-context > span {\n  display: block;\n  font-size: 8px;\n}\n.sb-original-idea {\n  margin: 18px 1px;\n  padding-top: 12px;\n  border-top: 1px solid var(--sb-line);\n  color: #9aa8bc;\n  font-size: 9px;\n}\n.sb-original-idea summary {\n  cursor: pointer;\n}\n.sb-original-idea p {\n  font-size: 10px;\n  line-height: 1.9;\n  margin-top: 10px;\n  white-space: pre-wrap;\n}\n.sb-palette {\n  display: flex;\n  height: 17px;\n  overflow: hidden;\n  border-radius: 5px;\n  border: 1px solid #e2e8f2;\n  margin: 15px 0 20px;\n}\n.sb-palette span {\n  flex: 1;\n}\n.sb-plan-page {\n  margin-bottom: 10px;\n  border: 1px solid #e5ebf5;\n  border-radius: 9px;\n  padding: 12px;\n}\n.sb-plan-page summary {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  color: #6b80a0;\n  font-size: 10px;\n  cursor: pointer;\n}\n.sb-plan-page summary > span {\n  flex: 1;\n  overflow-wrap: anywhere;\n}\n.sb-plan-page summary small {\n  color: #9dacbf;\n  font-size: 8px;\n}\n.sb-plan-page ol {\n  list-style: none;\n  margin: 13px 0 0 7px;\n  padding: 0 0 0 14px;\n  border-left: 1px solid #e4ebf7;\n}\n.sb-plan-page li {\n  position: relative;\n  font-size: 9px;\n  color: #94a3ba;\n  padding: 5px 0;\n}\n.sb-plan-page li > span {\n  position: absolute;\n  width: 5px;\n  height: 5px;\n  background: #dae5f5;\n  border-radius: 100%;\n  left: -17px;\n  top: 9px;\n}\n.sb-shared-sections {\n  padding: 17px 10px;\n}\n.sb-shared-sections p {\n  color: #9aa8bc;\n  font-size: 10px;\n  margin-top: 10px;\n}\n.sb-creation {\n  text-align: center;\n  padding-top: 6px;\n}\n.sb-site-symbol {\n  display: inline-grid;\n  place-items: center;\n  width: 70px;\n  height: 70px;\n  background: #f1f6ff;\n  border: 1px solid #e3edfe;\n  border-radius: 18px;\n  color: #739cda;\n  margin-bottom: 15px;\n}\n.sb-creation h3 {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 10px;\n  overflow-wrap: anywhere;\n}\n.sb-creation > .sb-status-pill {\n  margin-bottom: 25px;\n}\n.sb-build-stat {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 11px 0;\n  border-bottom: 1px solid #edf1f7;\n  font-size: 9px;\n  color: #9aa9bd;\n}\n.sb-build-stat strong {\n  color: #6d86aa;\n  font-weight: 500;\n}\n.sb-creation progress {\n  width: 100%;\n  height: 5px;\n  accent-color: var(--sb-blue);\n  border: none;\n  border-radius: 8px;\n  overflow: hidden;\n  margin: 13px 0;\n}\n.sb-creation progress::-webkit-progress-bar {\n  background: #edf2fa;\n}\n.sb-creation progress::-webkit-progress-value {\n  background: var(--sb-blue);\n  border-radius: 8px;\n}\n.sb-website-id {\n  text-align: left;\n  padding: 13px 10px 0;\n  border: 1px solid #e7edf6;\n  border-radius: 8px;\n  margin-top: 15px;\n}\n.sb-website-id code {\n  display: block;\n  font-size: 10px;\n  color: #8094b2;\n  margin-top: 8px;\n  overflow-wrap: anywhere;\n}\n.sb-deferred {\n  text-align: left;\n  border-top: 1px solid #e7edf6;\n  padding: 17px 0;\n  margin-top: 20px;\n}\n.sb-deferred h4 {\n  font-size: 11px;\n  color: #8f7d62;\n}\n.sb-deferred p {\n  font-size: 10px;\n  color: #a99d89;\n  line-height: 1.8;\n  margin-top: 5px;\n}\n.sb-deferred > div {\n  padding: 12px;\n  border: 1px solid #f1eade;\n  border-radius: 8px;\n  margin-top: 10px;\n}\n.sb-deferred strong {\n  font-size: 10px;\n  color: #958265;\n  font-weight: 500;\n}\n.sb-error,\n.sb-notice {\n  background: #fff8f5;\n  border: 1px solid #f2dfd6;\n  color: #ae735c;\n  padding: 12px 14px;\n  font-size: 11px;\n  line-height: 1.8;\n  border-radius: 9px;\n  white-space: pre-line;\n  margin: 7px 0 12px;\n  overflow-wrap: anywhere;\n}\n.sb-workspace-alert {\n  flex-shrink: 0;\n  max-height: 160px;\n  overflow-y: auto;\n  padding: 10px 25px;\n  background: #fff8f5;\n  border-bottom: 1px solid #f2dfd6;\n  color: #ae735c;\n  font-size: 11px;\n  line-height: 1.8;\n  white-space: pre-line;\n  overflow-wrap: anywhere;\n}\n.sb-workspace-alert > button {\n  display: block;\n}\n.sb-sync-error {\n  background: #fffbef;\n  border-bottom: 1px solid #f3ead4;\n  color: #a18c62;\n  padding: 10px 20px;\n  font-size: 10px;\n}\n.sb-sync-error button {\n  border: none;\n  background: none;\n  text-decoration: underline;\n  margin-left: 6px;\n}\n.sb-ready {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 10px;\n  color: #6d9f86;\n}\n.sb-muted {\n  color: var(--sb-muted);\n}\n.sb-spinner {\n  display: inline-block;\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n  border: 1.5px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 100%;\n  animation: sb-spin 0.8s linear infinite;\n}\n.sb-workspace-loading {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px;\n  height: 100%;\n  color: #8b9db9;\n  font-size: 12px;\n}\n.sb-workspace-loading h2 {\n  font-size: 20px;\n  color: #5b7397;\n}\n.sb-mobile-tabs,\n.sb-sessions-toggle {\n  display: none;\n}\n@keyframes sb-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes sb-think {\n  0%,\n  60%,\n  100% {\n    opacity: 0.3;\n  }\n  30% {\n    opacity: 1;\n  }\n}\n@media (min-width: 1650px) {\n  .sb-workspace-columns {\n    grid-template-columns: minmax(300px, 1fr) 390px;\n  }\n  .sb-messages {\n    padding: 25px 48px;\n  }\n  .sb-composer-area {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n  .sb-details {\n    padding-left: 28px;\n    padding-right: 28px;\n  }\n}\n@media (max-width: 1250px) {\n  .sb-sidebar {\n    flex-basis: 222px;\n    padding-left: 13px;\n    padding-right: 13px;\n  }\n  .sb-workspace-columns {\n    grid-template-columns: minmax(280px, 1fr) 305px;\n  }\n  .sb-details {\n    padding: 19px 17px 0;\n  }\n  .sb-new-site {\n    padding: 35px;\n  }\n  .sb-idea-art {\n    transform: scale(0.9);\n    transform-origin: right center;\n    width: 260px;\n  }\n  .sb-text-only {\n    display: none;\n  }\n}\n@media (max-width: 1050px) {\n  .sb-sidebar {\n    flex-basis: 205px;\n  }\n  .sb-sidebar-title {\n    margin-left: 0;\n    margin-right: 0;\n    gap: 7px;\n  }\n  .sb-sidebar-title strong {\n    font-size: 14px;\n  }\n  .sb-mobile-tabs {\n    display: flex;\n    flex-shrink: 0;\n    background: white;\n    border-bottom: 1px solid var(--sb-line);\n    padding: 0 25px;\n    gap: 20px;\n  }\n  .sb-mobile-tabs > button {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    border: none;\n    background: none;\n    padding: 12px 0;\n    font-size: 11px;\n    color: #9aa7bd;\n  }\n  .sb-mobile-tabs > button.is-active {\n    color: var(--sb-blue);\n    box-shadow: 0 2px var(--sb-blue);\n  }\n  .sb-workspace-columns {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .sb-show-chat > .sb-details,\n  .sb-show-details > .sb-conversation {\n    display: none;\n  }\n  .sb-show-details > .sb-details {\n    border: none;\n    padding: 22px 26px 0;\n  }\n  .sb-stage-card {\n    flex-shrink: 0;\n  }\n  .sb-new-site {\n    padding: 32px;\n    gap: 22px 0;\n  }\n  .sb-idea-art {\n    transform: scale(0.7);\n    width: 200px;\n  }\n  .sb-new-intro h1 {\n    font-size: 34px;\n  }\n  .sb-kicker {\n    font-size: 7px;\n    letter-spacing: 0.8px;\n  }\n  .sb-desktop-break {\n    display: none;\n  }\n  .sb-idea-options .sb-button {\n    margin-left: auto;\n  }\n}\n@media (max-width: 750px) {\n  .sb-app {\n    flex-direction: column;\n    position: relative;\n  }\n  .sb-global-header nav {\n    gap: 0;\n  }\n  .sb-global-header nav a {\n    font-size: 11px;\n    padding: 7px 8px;\n  }\n  .sb-global-header > div {\n    min-height: 70px;\n  }\n  .sb-sessions-toggle {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    flex-shrink: 0;\n    padding: 13px 20px;\n    background: white;\n    border: none;\n    border-bottom: 1px solid var(--sb-line);\n    color: #7588a4;\n    font-size: 11px;\n  }\n  .sb-sessions-toggle > svg:last-child {\n    margin-left: auto;\n    transform: rotate(90deg);\n  }\n  .sb-sidebar {\n    display: none;\n  }\n  .sb-sidebar.is-open {\n    display: flex;\n    position: absolute;\n    z-index: 10;\n    top: 44px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 22px;\n    box-shadow: 0 10px 30px #26446e13;\n  }\n  .sb-sidebar-footer {\n    max-width: 420px;\n  }\n  .sb-sidebar-title {\n    margin-bottom: 16px;\n  }\n  .sb-main {\n    width: 100%;\n  }\n  .sb-new-site {\n    padding: 30px 23px;\n    grid-template-columns: 1fr;\n    gap: 24px;\n    min-height: 100%;\n    align-content: start;\n  }\n  .sb-new-intro {\n    text-align: center;\n  }\n  .sb-new-intro h1 {\n    font-size: 36px;\n    margin-top: 15px;\n    letter-spacing: -1.6px;\n  }\n  .sb-new-intro p {\n    font-size: 11px;\n  }\n  .sb-kicker {\n    font-size: 6px;\n    letter-spacing: 0.9px;\n  }\n  .sb-idea-art {\n    display: none;\n  }\n  .sb-idea-form {\n    padding: 20px 17px 15px;\n    border-radius: 12px;\n  }\n  .sb-idea-form > textarea {\n    font-size: 11px;\n    min-height: 115px;\n  }\n  .sb-idea-options {\n    gap: 13px 8px;\n  }\n  .sb-session-name {\n    min-width: calc(100% - 90px);\n  }\n  .sb-idea-options .sb-button {\n    width: 100%;\n  }\n  .sb-idea-starters > div {\n    gap: 7px;\n  }\n  .sb-idea-starters button {\n    padding: 12px 10px;\n  }\n  .sb-idea-starters strong {\n    font-size: 10px;\n    line-height: 1.5;\n  }\n  .sb-idea-starters p {\n    font-size: 8px;\n  }\n  .sb-idea-starters button > svg {\n    display: none;\n  }\n  .sb-new-footnote {\n    gap: 7px;\n    font-size: 7px;\n    margin-top: 0;\n  }\n  .sb-new-footnote i {\n    width: 12px;\n  }\n  .sb-workspace-header {\n    padding: 18px 20px 15px;\n    gap: 7px;\n  }\n  .sb-workspace-header h1 {\n    font-size: 18px;\n  }\n  .sb-workspace-header-actions {\n    gap: 6px;\n  }\n  .sb-status-pill {\n    font-size: 8px;\n  }\n  .sb-steps {\n    padding: 0 20px 16px;\n    gap: 5px;\n    overflow-x: auto;\n  }\n  .sb-steps li {\n    font-size: 8px;\n    gap: 4px;\n  }\n  .sb-steps li > span {\n    width: 15px;\n    height: 15px;\n    font-size: 7px;\n  }\n  .sb-steps li:not(:last-child)::after {\n    min-width: 5px;\n  }\n  .sb-mobile-tabs {\n    padding: 0 20px;\n  }\n  .sb-conversation-top {\n    padding: 14px 20px;\n  }\n  .sb-messages {\n    padding: 18px 20px;\n  }\n  .sb-message {\n    max-width: 100%;\n  }\n  .sb-message-user {\n    margin-left: 16px;\n  }\n  .sb-message-content {\n    font-size: 12px;\n  }\n  .sb-composer-area {\n    padding: 12px 15px 15px;\n  }\n  .sb-composer-hint {\n    font-size: 7px;\n  }\n  .sb-composer-hint > span:last-child {\n    display: none;\n  }\n  .sb-conversation-start {\n    font-size: 6px;\n    letter-spacing: 1px;\n  }\n}\n@media (max-width: 750px) {\n  .sb-message-content,\n  .sb-idea-form > textarea,\n  .sb-welcome-message p {\n    font-size: 14px;\n  }\n  .sb-idea-form > textarea,\n  .sb-composer textarea,\n  .sb-session-name input,\n  .sb-search input {\n    font-size: 16px;\n  }\n  .sb-details-heading h2 {\n    font-size: 13px;\n  }\n  .sb-stage-card p,\n  .sb-plan-page summary,\n  .sb-build-stat {\n    font-size: 12px;\n  }\n  .sb-panel-tabs > button,\n  .sb-stage-card .sb-button,\n  .sb-mobile-tabs > button {\n    font-size: 12px;\n    min-height: 42px;\n  }\n  .sb-icon-button {\n    width: 38px;\n    height: 38px;\n  }\n  .sb-composer-actions {\n    width: 100%;\n  }\n  .sb-composer-actions .sb-button {\n    flex: 1;\n    min-height: 42px;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .sb-page *,\n  .sb-page *::before,\n  .sb-page *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    scroll-behavior: auto !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n.sb-build-progress {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 12px;\n  padding: 14px 16px;\n  border: 1px solid #cbdcff;\n  border-radius: 16px;\n  background: linear-gradient(145deg, #f8fbff 0%, #f4f7ff 55%, #f9f5ff 100%);\n}\n.sb-build-progress__title {\n  color: #1f2e49;\n  font-size: 14px;\n  font-weight: 700;\n}\n.sb-build-progress__steps {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 16px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.sb-build-progress__steps li {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  color: #7a8496;\n  font-size: 12px;\n  font-weight: 600;\n}\n.sb-build-progress__mark {\n  display: grid;\n  width: 20px;\n  height: 20px;\n  place-items: center;\n  border: 1px solid #ccd8ef;\n  border-radius: 50%;\n  background: #fff;\n  color: #7a8496;\n  font-size: 10px;\n  font-weight: 700;\n}\n.sb-build-progress__steps li.is-done {\n  color: #287447;\n}\n.sb-build-progress__steps li.is-done .sb-build-progress__mark {\n  border-color: #dff4e7;\n  background: #dff4e7;\n  color: #287447;\n}\n.sb-build-progress__steps li.is-active {\n  color: #1f2e49;\n}\n.sb-build-progress__steps li.is-active .sb-build-progress__mark {\n  border: 2px solid #dce5f7;\n  border-top-color: #4b7cff;\n  animation: sb-build-progress-spin 0.9s linear infinite;\n}\n.sb-build-progress__steps li.is-failed {\n  color: #b42318;\n}\n.sb-build-progress__steps li.is-failed .sb-build-progress__mark {\n  border-color: #fde2df;\n  background: #fde2df;\n  color: #b42318;\n}\n.sb-build-progress__note {\n  margin: 0;\n  color: #596983;\n  font-size: 12px;\n}\n.sb-build-progress__error {\n  margin: 0;\n  color: #b42318;\n  font-size: 12px;\n  line-height: 1.45;\n  overflow-wrap: anywhere;\n}\n@keyframes sb-build-progress-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .sb-build-progress__steps li.is-active .sb-build-progress__mark {\n    animation: none;\n  }\n}\n\n.sb-summary-editor-hint { font-size: 12px; line-height: 1.65; color: #617295; }\n.sb-summary-line { display: flex; align-items: flex-start; gap: 5px; margin: 5px 0; }\n.sb-summary-edit-text { flex: 1; min-width: 0; padding: 5px; margin-left: -5px; border: 0; border-radius: 5px; background: transparent; color: inherit; font: inherit; line-height: 1.7; text-align: left; white-space: pre-wrap; overflow-wrap: anywhere; cursor: text; }\n.sb-summary-edit-text:hover, .sb-summary-edit-text:focus-visible { background: #f0f4ff; outline: 1px solid #dce4ff; }\n.sb-summary-line-heading { margin-top: 18px; font-size: 13px; font-weight: 700; }\n.sb-summary-line textarea { flex: 1; min-width: 0; width: 100%; padding: 8px; border: 1px solid #8ba7ff; border-radius: 7px; background: #fff; color: #20304f; font: inherit; line-height: 1.7; resize: vertical; }\n.sb-summary-remove { border: 0; background: transparent; color: #8191ad; padding: 5px; font-size: 18px; cursor: pointer; }\n.sb-summary-remove:hover, .sb-summary-remove:focus-visible { color: #b54242; }\n.sb-summary-edit-tools { display: flex; flex-wrap: wrap; gap: 14px; margin: 14px 0; }\n.sb-summary-edit-tools button { border: 0; padding: 3px 0; background: transparent; color: #2956db; font: inherit; font-size: 11px; cursor: pointer; }\n.sb-summary-save-row { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 10px; margin: 12px 0; color: #8191ad; font-size: 10px; }\n.sb-summary-editor button:disabled { cursor: default; opacity: .55; }\n@media (max-width: 600px) {\n  .sb-summary-edit-text { padding-top: 10px; padding-bottom: 10px; }\n  .sb-summary-remove { padding: 10px; }\n  .sb-summary-line textarea { font-size: 16px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
